"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StaticTextControl = exports.NumericTextBoxControl = exports.FTComboBoxControl = exports.AddEmptyEntry = exports.FTComboBoxState = exports.MethodButtonControl = exports.TextBoxControl = exports.FieldControl = exports.Control = exports.FTControlValueDataType = exports.FontOptions = exports.ControlFactory = exports.ControlCollection = void 0;
const tslib_1 = require("tslib");
require("@progress/kendo-ui");
require("babel-polyfill");
const $ = require("jquery");
require("jquery-ui-bundle");
require("jquery-ui-bundle/jquery-ui.css");
const _ = require("underscore");
require("jquery-address");
const Utilities_1 = require("../../javascript/Utilities");
require("../ErrorDialog/ErrorDialog.js");
const MethodManager_1 = require("../Menu/MethodManager");
const ExternalInputFactory_1 = require("./ExternalInputs/ExternalInputFactory");
const MVPicker_1 = require("./ExternalInputs/MVPicker");
const Instance_1 = require("../../model/Instance");
const PropertyPageExtendedSearch_1 = require("./PropertyPageExtendedSearch");
const Base_1 = require("../../model/Base");
const risLinkMarkup = require("../../templates/SynerisRis.tmpl.html");
const gl_animationDuration = 100;
//#endregion Interfaces
//#region Classes
/** Encapsulates a control structure */
class ControlCollection {
    constructor() {
        this.controlsByFieldName = {};
        this.controlsByPresentedFieldName = {};
        this.allControls = [];
        // Special case for PropertyPageMode === Search: Method buttons may appear inside the extended search dialog,
        // but not inside the search propertypage, so they have to be stored separately
        this.buttonControlDefsForExtendedSearch = {};
    }
    pushControl(control) {
        this.allControls.push(control);
    }
}
exports.ControlCollection = ControlCollection;
/** Factory class for property page controls */
class ControlFactory {
    constructor(propertyPagejQuery, instance, typeId, mode, notNullFields, options, triggerFields) {
        this.propertyPagejQuery = propertyPagejQuery;
        this.instance = instance;
        this.typeId = typeId;
        this.notNullFields = notNullFields;
        this.options = options;
        this.triggerFields = triggerFields;
        this.workingInstance = new Instance_1.Instance();
        this.oldTriggerFieldValue = {};
        this.mode = mode;
        this.prependId = propertyPagejQuery.attr("id");
        this.controlCollection = new ControlCollection();
        this.updateOldTriggerFieldValues(instance);
    }
    setNewInstance(newInst) {
        var _a;
        const that = this;
        this.instance = newInst;
        this.workingInstance = new Instance_1.Instance();
        //This assumes:
        // * The typeid hasn't changed!
        if (that.controlCollection) {
            // ...and set each changed value to the corresponding control
            for (let prop in this.instance.items) {
                let coll = that.controlCollection.controlsByFieldName[prop];
                if (coll && coll.Input) {
                    let fc = coll.Input;
                    let val = newInst.items[prop].value;
                    if (fc instanceof FTComboBoxControl) {
                        fc.setValue({
                            id: newInst.items[fc.field.presentedField].value,
                            value: val
                        });
                    }
                    else {
                        if (fc instanceof ImageControl && val == undefined)
                            val = (_a = newInst.items[prop + "_icon"]) === null || _a === void 0 ? void 0 : _a.value;
                        fc.setValue(val);
                    }
                }
            }
        }
    }
    changeInstance(newInst) {
        //This assumes:
        // * The typeid hasn't changed!
        const that = this;
        if (that.controlCollection) {
            // get all fields that have been changed
            let instanceDiffPropNames = new Set();
            let current = this.getCurrentInstance();
            let newInstAsInstance;
            let newInstAsStringDict = {};
            let bNewItemsFromInstance = false;
            if (newInst instanceof Instance_1.Instance) {
                bNewItemsFromInstance = true;
                newInstAsInstance = newInst;
            }
            else {
                bNewItemsFromInstance = false;
                newInstAsStringDict = newInst;
            }
            if (bNewItemsFromInstance) {
                for (let prop in current.items) {
                    if (current.items.hasOwnProperty(prop) && newInstAsInstance.items.hasOwnProperty(prop)) {
                        if (!current.items[prop].isEqual(newInstAsInstance.items[prop]))
                            instanceDiffPropNames.add(prop);
                    }
                }
            }
            else {
                for (let prop in current.items) {
                    if (current.items.hasOwnProperty(prop) && newInstAsStringDict.hasOwnProperty(prop)) {
                        // Diese Werte wurden als key/value-Paare übergeben und liegen als string vor (sie stammen z.B. aus der url) --> diese Werte werden auf alle Fälle verarbeitet bzw. weiter unten müssen sie mittels fc.convertBack konvertiert werden.
                        // Das entspricht dem bisherigen Verhalten!
                        instanceDiffPropNames.add(prop);
                    }
                }
            }
            // ...and set each changed value to the corresponding control
            for (let prop of instanceDiffPropNames) {
                let coll = that.controlCollection.controlsByFieldName[prop];
                if (coll && coll.Input) {
                    let fc = coll.Input;
                    let val;
                    if (bNewItemsFromInstance)
                        val = newInstAsInstance.items[prop].value;
                    else
                        val = fc.convertBack(newInstAsStringDict[prop]);
                    if (fc instanceof FTComboBoxControl) {
                        if (instanceDiffPropNames.has(fc.field.presentedField)) {
                            let presentedValue;
                            if (bNewItemsFromInstance)
                                presentedValue = newInstAsInstance.items[fc.field.presentedField].value;
                            else
                                presentedValue = newInstAsStringDict[fc.field.presentedField];
                            if (that.mode !== Base_1.PropertyPageMode.Search)
                                fc.setValue({
                                    id: presentedValue,
                                    value: val
                                });
                        }
                        else
                            fc.setValueString(fc.convert(val));
                    }
                    else
                        fc.setValue(val);
                }
                else {
                    coll = that.controlCollection.controlsByPresentedFieldName[prop];
                    if (coll) {
                        let presentedValue;
                        if (bNewItemsFromInstance)
                            presentedValue = newInstAsInstance.items[prop].value;
                        else
                            presentedValue = newInstAsStringDict[prop];
                        this.setWorkingValue(prop, presentedValue);
                        if (coll.length) {
                            $.each(coll, (idx, c) => {
                                if (c.Input) {
                                    c.Input.notifyDependentControls();
                                    c.Input.notifyChange();
                                    return false;
                                }
                            });
                        }
                    }
                }
            }
        }
    }
    setWorkingValue(fieldName, value) {
        if (!this.workingInstance.items.hasOwnProperty(fieldName)) {
            this.workingInstance.items[fieldName] = this.instance.items[fieldName].clone();
        }
        let v = value;
        if (v == undefined && this.mode === Base_1.PropertyPageMode.Search)
            v = "";
        this.workingInstance.items[fieldName].value = v;
    }
    getWorkingValue(fieldName, isMultiValueField) {
        if (this.workingInstance.items[fieldName])
            return this.workingInstance.items[fieldName].value;
        if (this.mode === Base_1.PropertyPageMode.Search)
            return "";
        return (isMultiValueField ? [] : undefined);
    }
    hasWorkingValue(fieldName) {
        return this.workingInstance.hasField(fieldName);
    }
    deleteWorkingValue(fieldName) {
        this.workingInstance.removeField(fieldName);
    }
    instanceHasChanged(changedFields) {
        let orig = this.instance;
        let current = this.getCurrentInstance();
        let hasChanged = false;
        for (let instanceKey in orig.items) {
            let origField = orig.items[instanceKey];
            // Begründung für die untere Änderung:
            // isFTRepresentativeField ist an dieser Stelle nicht vorhanden.
            // Das machte in folgenden Fällen Probleme:
            // War ein hard deleted FT-Entry eingestellt, wurde das IMMER als Änderung interpretiert, da sich der Text des FT-Fields unterschieden hat.
            // currentField.value="111111 (nicht mehr verfügbar)"
            // origField.value=undefined
            // if (origField.isFTRepresentativeField)
            if (origField.isFTField)
                continue;
            let currentField = current.items[instanceKey];
            if (!origField.isEqual(currentField)) {
                if (changedFields)
                    changedFields.push(instanceKey);
                hasChanged = true;
            }
        }
        return hasChanged;
    }
    triggerFieldHasChanged(currentInstance) {
        let hasChanged = false;
        if ((this.triggerFields != undefined) && (this.triggerFields.length > 0)) {
            for (let instanceKey of this.triggerFields) {
                let newValue = currentInstance.items[instanceKey];
                if (newValue) {
                    let oldValue = this.oldTriggerFieldValue[instanceKey];
                    if (!oldValue.isEqual(newValue)) {
                        hasChanged = true;
                        break;
                    }
                }
            }
        }
        return hasChanged;
    }
    updateOldTriggerFieldValues(currentInstance) {
        if ((this.triggerFields != undefined) && (this.triggerFields.length > 0)) {
            for (let instanceKey of this.triggerFields) {
                let curValue = currentInstance.items[instanceKey];
                if (curValue)
                    this.oldTriggerFieldValue[instanceKey] = curValue.clone();
            }
        }
    }
    getCurrentInstance(clearDynInvisibleValues = false) {
        const that = this;
        if (that.instance) {
            let currentInstance = that.instance.clone();
            let bForExternalInput = false;
            $.each(that.instance.items, (instanceKey, field) => {
                let newField = field.clone();
                let coll = that.controlCollection.controlsByFieldName[instanceKey];
                if (coll && coll.Input && coll.Input.forExternalInput)
                    bForExternalInput = true;
                else
                    bForExternalInput = false;
                if (that.workingInstance.items[instanceKey])
                    newField = that.workingInstance.items[instanceKey];
                else {
                    if (coll && coll.Input && !(coll.Input instanceof ImageControl)) {
                        let val = coll.Input.getValue();
                        if (!val) {
                            if (coll.Input instanceof ButtonGroupControl) {
                                let idForButtonGroup = that.instance.items[instanceKey].valueAsString; // da muss der value immer ein string sein
                                if (idForButtonGroup) {
                                    if (!coll.Input.hasButtonForId(idForButtonGroup))
                                        // Special case: Id field is non-empty but, for some reason, 
                                        // the button is not currently present. So keep the old id.
                                        val = idForButtonGroup;
                                }
                            }
                        }
                        else {
                            if (that.mode === Base_1.PropertyPageMode.Search) {
                                if ((typeof val !== "string") && (val != undefined)) {
                                    // In Search mode the value must be of type string! So convert it
                                    // (this occurs in the extended search - for expample if you enter a filter in a date field)
                                    switch (coll.Input.field.fieldType) {
                                        case "Date":
                                        case "DateTime":
                                        case "Time":
                                            val = kendo.toString(val, PropertyPageExtendedSearch_1.ExtendedSearchDialog.InternalDateFormat);
                                            break;
                                        default:
                                            val = coll.Input.convert(val, true);
                                            break;
                                    }
                                }
                            }
                        }
                        // Button groups are a special case: They need to fetch the FT entries right from the start, so 
                        // getCurrenInstance may not rely on their values before they have been initialized.
                        if (!(coll.Input instanceof ButtonGroupControl) || (coll.Input.initialized))
                            newField.value = val;
                    }
                }
                // When searching, typed fields (float, date etc.) might hold non-convertible strings
                // (e.g. boolean operators). To account for this, the instance for searching must hold a 
                // special flag that ensures literal string conversion instead of parsing on the server-side.
                if (that.mode === Base_1.PropertyPageMode.Search)
                    newField.searchExpression = true;
                currentInstance.items[instanceKey] = newField;
            });
            if (clearDynInvisibleValues)
                currentInstance = that.ClearAllDynamicInvisibleValues(currentInstance);
            return currentInstance;
        }
        return undefined;
    }
    raiseOnChange(that, manualChange) {
        if ((that.onChange) || (that.onTriggerFieldChanged)) {
            let curInstance = that.getCurrentInstance();
            if (that.onTriggerFieldChanged) {
                if (that.triggerFieldHasChanged(curInstance))
                    that.onTriggerFieldChanged(curInstance);
            }
            let changedFields = [];
            if (that.onChange) {
                if (that.instanceHasChanged(changedFields))
                    that.onChange(changedFields, curInstance, manualChange);
                else
                    that.onChange(undefined, undefined, manualChange);
            }
        }
        window.waitConditions.set("propertyPageOnChangeRaised");
    }
    raiseOnFullRefresh(that) {
        if (that.onFullRefresh)
            that.onFullRefresh();
    }
    raiseControlChange(control) {
        if (this.onControlChange)
            this.onControlChange(control);
    }
    raiseControlRecreated(control) {
        if (this.onControlRecreated)
            this.onControlRecreated(control);
    }
    raiseOnDisposeExtendedSearchButton(control, immediately = false) {
        if ((control.mode === Base_1.PropertyPageMode.Search) && !control.forExternalInput) {
            let propertyPagejQuery = this.propertyPagejQuery;
            window.clearTimeout(control.removeExtendedSearchButtonTimeoutId);
            let removeCallBack = () => { propertyPagejQuery.find('#btnExtendedSearch_' + control.id).remove(); };
            if (immediately)
                removeCallBack();
            else
                control.removeExtendedSearchButtonTimeoutId = window.setTimeout(removeCallBack, 500);
        }
    }
    raiseOnRequestExtendedSearchButton(control) {
        const that = this;
        let jqueryElem;
        let extendedSearchButton;
        // Erweiterte Suche
        // If we are not in search mode, we don't display the extended search button
        if (control.mode !== Base_1.PropertyPageMode.Search)
            return;
        // The current control is already displayed in an external input dialog, so we don't display the extended search button
        if (control.forExternalInput)
            return;
        // The current control is readonly for external input dialogs, so we don't display the extended search button
        if (control.readonlyForExtInput)
            return;
        if (!control.field.multiValue) {
            // For single value date, time and datetime controls, we don't display the extended search button,
            // because we have a special picker control for these field types.
            let fieldType = control.field.fieldType;
            if (fieldType === "Date" || fieldType === "DateTime" || fieldType === "Time")
                return;
        }
        that.propertyPagejQuery.find('.btnExtendedSearch').remove();
        window.clearTimeout(control.removeExtendedSearchButtonTimeoutId);
        let controlColl = control.controlFactory.controlCollection.controlsByFieldName[control.field.fieldName];
        jqueryElem = control.getDOMControl();
        extendedSearchButton = $("<button type='button' class='btn btn-default btnExtendedSearch' id='btnExtendedSearch_" + control.id + "'><i class='fa fa-list-alt'></i></button>")
            .css({
            height: control.getDOMControl().height() + "px",
            top: control.top + "px",
            left: (control.left + control.width) + "px",
        })
            .appendTo(jqueryElem.parent());
        if (!(control instanceof FTComboBoxControl))
            extendedSearchButton.css("left", extendedSearchButton.position().left - extendedSearchButton.width() + "px");
        extendedSearchButton.on("click", (e) => {
            window.clearTimeout(control.removeExtendedSearchButtonTimeoutId);
            e.stopPropagation();
            e.preventDefault();
            let buttonControlDef = control.controlFactory.controlCollection.buttonControlDefsForExtendedSearch[controlColl.Input.field.fieldName] || undefined;
            let dlg = new PropertyPageExtendedSearch_1.ExtendedSearchDialog(controlColl, control.controlFactory.getCurrentInstance(), "", buttonControlDef);
            dlg.show((cancelled, changedInstance) => {
                that.raiseOnDisposeExtendedSearchButton(control, true);
                if (!cancelled) {
                    control.controlFactory.changeInstance(changedInstance);
                    control.highlightIfMandatoryAndEmpty();
                    control.controlFactory.raiseOnChange(control.controlFactory, true);
                }
            });
        });
    }
    raiseOnSearch(that) {
        that.raiseOnChange(that, false);
        if (that.onSearch) {
            that.onSearch();
        }
    }
    raiseOnFtFieldChange(that) {
        if (that.onFtFieldChange)
            that.onFtFieldChange(that.getCurrentInstance());
    }
    raiseonFtDataBound(e, controlFactory) {
        if (controlFactory.onFtDataBound)
            controlFactory.onFtDataBound(e, controlFactory.getCurrentInstance());
    }
    raiseOnBoolFieldChange(that) {
        if (that.onBoolFieldChange)
            that.onBoolFieldChange(that.getCurrentInstance());
    }
    /**
     * Returns an intuitive display field title for validation errors.
     *
     * @param fieldName Fieldname for which to return title.
     */
    getDisplayTitleForValidationErrors(fieldName) {
        const that = this;
        let text;
        let coll = that.controlCollection.controlsByFieldName[fieldName];
        if (coll && coll.Input)
            text = coll.Input.field.fieldTitle || coll.Input.field.fieldName;
        else {
            let collArr = that.controlCollection.controlsByPresentedFieldName[fieldName];
            if (collArr && collArr.length) {
                // Get the first (by taborder) Static control's nonempty text
                let tabOrderedTexts = {};
                $.each(collArr, (idx, coll) => {
                    let inputControl = coll.Input;
                    let staticControl = coll.Static;
                    if (inputControl && staticControl && staticControl.text)
                        tabOrderedTexts[inputControl.tabOrder.toString()] = staticControl.text;
                });
                let keys = Object.keys(tabOrderedTexts);
                if (keys.length) {
                    // Get minimum taborder by converting the object keys to int and taking the 
                    // minimum int from the resulting array
                    let minTabOrder = Math.min.apply(Math, keys.map((val => parseInt(val, 10))));
                    text = tabOrderedTexts[minTabOrder.toString()];
                }
            }
        }
        if (!text)
            text = Utilities_1.synUtil.Strings.getValue(fieldName, fieldName, that.typeId);
        return text;
    }
    notifyIgnoreField(fieldName) {
        let msgFmt = Utilities_1.synUtil.Strings.getValue("webtoolkit.unsavedchangesignoredmsg");
        let fieldTitle = this.getDisplayTitleForValidationErrors(fieldName);
        Utilities_1.synUtil.Notifications.info(kendo.format(Utilities_1.synUtil.convertFormatString(msgFmt), fieldTitle));
    }
    pushControl(controlDef) {
        let controlClass;
        const that = this;
        switch (controlDef.type) {
            case "PanelInfo":
            case "GroupBoxInfo":
                controlClass = Panel;
                break;
            case "HLineInfo":
            case "VLineInfo":
                controlClass = LineControl;
                break;
            case "StaticTextInfo":
            case "LayoutStaticTextInfo":
                controlClass = StaticTextControl;
                break;
            case "StaticIconInfo":
                controlClass = StaticImageControl;
                break;
            case "TextBoxInfo":
            case "DateTextBoxInfo":
            case "TimeTextBoxInfo":
            case "DateAndTimeTextBoxInfo":
                controlClass = TextBoxControl;
                break;
            case "MultiValueButtonInfo":
                controlClass = MultiValueButtonControl;
                break;
            case "MethodButtonInfo":
                controlClass = MethodButtonControl;
                break;
            case "DateTimeSearchButtonInfo":
                controlClass = DateTimeSearchButtonControl;
                break;
            case "FTComboBoxInfo":
                controlClass = FTComboBoxControl;
                break;
            case "NumericTextBoxInfo":
                controlClass = NumericTextBoxControl;
                break;
            case "DateCtrlInfo":
            case "TimeCtrlInfo":
            case "DateAndTimeCtrlInfo":
                controlClass = DateControl;
                break;
            case "CheckBoxInfo":
                controlClass = CheckBoxControl;
                break;
            case "BoolComboBoxInfo":
                controlClass = BoolComboBoxControl;
                break;
            case "CheckBoxGroupCtrlInfo":
            case "RadioButtonGroupCtrlInfo":
                controlClass = ButtonGroupControl;
                break;
            case "ImageInfo":
                controlClass = ImageControl;
                break;
            default:
                break;
        }
        if (controlClass) {
            if (controlDef.type === "MethodButtonInfo" && that.mode === Base_1.PropertyPageMode.Search && !controlDef.forExternalInput) {
                that.controlCollection.buttonControlDefsForExtendedSearch[controlDef.field.fieldName] = controlDef;
                return;
            }
            let control = new controlClass(this.prependId, this.typeId, this.mode, controlDef, this);
            if (control instanceof StaticTextControl)
                control.mandatoryColor = this.options.mandatoryFieldColor;
            else {
                if (control instanceof FieldControl) {
                    let fieldType = control.field.fieldType;
                    let val = this.instance.items[control.field.fieldName].value;
                    if (this.instance.ftEntries[control.field.fieldName].hardDeleted && fieldType === "String")
                        val = kendo.format(control.hardDeletedFormatString, this.instance.items[control.field.presentedField].value);
                    if (controlDef.initialValue == undefined) {
                        control.initialValue = val;
                        control.initialFTEntries = this.instance.ftEntries[control.field.fieldName];
                        if (control instanceof TextBoxControl) {
                            let iconField = control.field.fieldName + "_icon";
                            if (this.instance.items.hasOwnProperty(iconField))
                                control.iconUrl = this.instance.items[iconField].valueAsString;
                        }
                        else if (control instanceof FTComboBoxControl) {
                            if (controlDef.forExternalInput)
                                control.initialValue = undefined;
                            else {
                                let v = FTControlValueDataType.fromJSON({ id: this.instance.items[control.field.presentedField].valueAsString, value: val });
                                if ((control.field.fieldConstraint & 32768) && control.field.isFTRepresentativeField) {
                                    let iconField = control.field.fieldName + "_icon";
                                    if (this.instance.items[iconField] && this.instance.items[iconField].value)
                                        v.ceimage = this.instance.items[iconField].valueToString();
                                }
                                if (this.instance.ftEntries[control.field.fieldName].softDeleted)
                                    v.softDeleted = true;
                                if (this.instance.ftEntries[control.field.fieldName].showSoftDeletedWarning)
                                    v.showSoftDeletedWarning = true;
                                else if (this.instance.ftEntries[control.field.fieldName].hardDeleted)
                                    v.hardDeleted = true;
                                if (this.instance.ftEntries[control.field.fieldName].isAbstract)
                                    v.isAbstract = true;
                                control.initialValue = v;
                            }
                        }
                    }
                    else if (control instanceof FTComboBoxControl)
                        control.initialValue = FTControlValueDataType.fromJSON(controlDef.initialValue);
                    else
                        control.initialValue = controlDef.initialValue;
                }
            }
            that.controlCollection.pushControl(control);
        }
    }
    create() {
        const that = this;
        let elem;
        // Sort controls: layout elements like panels, groupboxes etc. first,
        // then the controls themselves. this prevents stacking issues.
        that.controlCollection.allControls.sort((a, b) => {
            let isLayoutElem = (elem) => {
                return (elem instanceof LineControl
                    || elem instanceof Panel
                    || elem instanceof StaticTextControl
                    || elem instanceof StaticImageControl);
            };
            let aIsLayoutElem = isLayoutElem(a);
            let bIsLayoutElem = isLayoutElem(b);
            return ((aIsLayoutElem < bIsLayoutElem) ? 1 : ((aIsLayoutElem > bIsLayoutElem) ? -1 : 0));
        });
        for (let i = 0; i < that.controlCollection.allControls.length; i++) {
            elem = that.controlCollection.allControls[i].tojQuery().appendTo(this.propertyPagejQuery);
            that.controlCollection.allControls[i].init(elem);
        }
        // Build fieldcontrol structure
        let fields = [];
        // Foreach FieldControl, add the field to the array. Make sure to only add it once
        $.each(that.controlCollection.allControls, (idx, elem) => {
            if (elem instanceof FieldControl) {
                // Only add if fields array does not yet contain this field
                let field = elem.field;
                if (!$.grep(fields, (el) => { return el.fieldName === field.fieldName; }).length)
                    fields.push(field);
            }
        });
        let getControlKey = (control) => {
            let controlKey;
            if (control.field)
                controlKey = control.field.fieldName;
            else {
                if (control.key.match(/\.Input$|\.Static$|\.Button$/))
                    controlKey = control.key.substring(0, control.key.lastIndexOf("."));
                else
                    controlKey = control.key;
            }
            return controlKey;
        };
        $.each(that.controlCollection.allControls, (idx, control) => {
            let controlKey = getControlKey(control);
            if (!that.controlCollection.controlsByFieldName.hasOwnProperty(controlKey))
                that.controlCollection.controlsByFieldName[controlKey] = {};
            let controlType = control.key.substring(control.key.lastIndexOf(".") + 1);
            if (!controlType.match(/Input$|Static$|Button$/))
                controlType = "Input";
            that.controlCollection.controlsByFieldName[controlKey][controlType] = control;
        });
        $.each(that.controlCollection.allControls, (idx, control) => {
            if (control instanceof FieldControl) {
                let field = control.field;
                if (field && field.isFTRepresentativeField) {
                    if (!that.controlCollection.controlsByPresentedFieldName.hasOwnProperty(field.presentedField))
                        that.controlCollection.controlsByPresentedFieldName[field.presentedField] = [];
                    let collToAdd = that.controlCollection.controlsByFieldName[field.fieldName];
                    let matchingItems = $.grep(that.controlCollection.controlsByPresentedFieldName[field.presentedField], (elem) => {
                        if (elem.Input && collToAdd.Input)
                            if (elem.Input.key === collToAdd.Input.key)
                                return true;
                        if (elem.Static && collToAdd.Static)
                            if (elem.Static.key === collToAdd.Static.key)
                                return true;
                        if (elem.Button && collToAdd.Button)
                            if (elem.Button.key === collToAdd.Button.key)
                                return true;
                        return false;
                    });
                    if (!matchingItems.length)
                        that.controlCollection.controlsByPresentedFieldName[field.presentedField].push(collToAdd);
                }
            }
        });
        $.each(fields, (idx, field) => {
            let controls = that.controlCollection.controlsByFieldName[field.fieldName];
            if (controls.Input && controls.Input instanceof FieldControl) {
                let fc = controls.Input;
                if (field.parentFTPresentedField) {
                    let parentControls = that.controlCollection.controlsByPresentedFieldName[field.parentFTPresentedField];
                    if (parentControls) {
                        $.each(parentControls, (idx2, coll) => {
                            if (coll.Input)
                                fc.parentControls.push(coll.Input);
                        });
                    }
                    else {
                        //might be buttongroup
                        parentControls = that.controlCollection.controlsByFieldName[field.parentFTPresentedField];
                        if (parentControls && parentControls.Input)
                            fc.parentControls.push(parentControls.Input);
                    }
                }
                if (field.childFTPresentedFields) {
                    $.each(field.childFTPresentedFields, (idx, childField) => {
                        let childControls = that.controlCollection.controlsByPresentedFieldName[childField];
                        if (childControls) {
                            $.each(childControls, (idx2, coll) => {
                                if (coll.Input)
                                    fc.childControls.push(coll.Input);
                            });
                        }
                        else {
                            //might be buttongroup
                            childControls = that.controlCollection.controlsByFieldName[childField];
                            if (childControls && childControls.Input)
                                fc.childControls.push(childControls.Input);
                        }
                    });
                }
                if (field.otherRepresentativeFields) {
                    $.each(field.otherRepresentativeFields, (idx, otherField) => {
                        let otherControls = that.controlCollection.controlsByFieldName[otherField];
                        if (otherControls && otherControls.Input)
                            fc.otherRepresentativeControls.push(otherControls.Input);
                    });
                }
            }
        });
        if (elem)
            for (let i = 0; i < that.controlCollection.allControls.length; i++)
                that.controlCollection.allControls[i].lateInit(elem);
        return that.controlCollection;
    }
    IsSomeThingVisibleDynamicInternal(control) {
        let bReturn = false;
        if (control) {
            if (control.Input)
                bReturn = control.Input.visibleDynamic;
            if ((!bReturn) && (control.Static))
                bReturn = control.Static.visibleDynamic;
            if ((!bReturn) && (control.Button))
                bReturn = control.Button.visibleDynamic;
        }
        return bReturn;
    }
    IsSomeThingVisibleDynamic(control) {
        const that = this;
        let bReturn = false;
        if (control) {
            bReturn = that.IsSomeThingVisibleDynamicInternal(control);
            if (!bReturn) {
                if (control.Input) {
                    if ((control.Input.otherRepresentativeControls)) {
                        for (let otherControl in control.Input.otherRepresentativeControls) {
                            bReturn = that.IsSomeThingVisibleDynamicInternal(otherControl);
                            if (bReturn)
                                break;
                        }
                    }
                    if ((!bReturn) && (control.Input.field.presentedField)) {
                        let controlPresented = that.controlCollection.controlsByPresentedFieldName[control.Input.field.presentedField];
                        if (controlPresented)
                            bReturn = that.IsSomeThingVisibleDynamicInternal(controlPresented);
                    }
                }
            }
        }
        return bReturn;
    }
    ClearAllDynamicInvisibleValues(instance) {
        const that = this;
        let convertedInstance = instance.clone();
        for (let instanceKey in instance.items) {
            let control = that.controlCollection.controlsByFieldName[instanceKey];
            if (control) {
                if (!that.IsSomeThingVisibleDynamic(control)) {
                    let field = convertedInstance.items[instanceKey];
                    if (field) {
                        let ftKeyField = undefined;
                        if (field.fieldDef.isFTField)
                            ftKeyField = field.fieldDef.ftKeyField;
                        else if (field.fieldDef.isFTKeyField)
                            ftKeyField = field.fieldDef;
                        if (ftKeyField) {
                            // Bei einem FT-Feld auch alle dazugehörigen Felder ausleeren
                            let instanceField = convertedInstance.items[ftKeyField.name];
                            if (instanceField)
                                instanceField.clear();
                            for (let ftField of ftKeyField.ftFields) {
                                instanceField = convertedInstance.items[ftField.name];
                                if (instanceField)
                                    instanceField.clear();
                            }
                        }
                        else {
                            field.clear();
                        }
                    }
                }
            }
        }
        return convertedInstance;
    }
}
exports.ControlFactory = ControlFactory;
//#region Control classes
class FontOptions {
    constructor() {
        this.height = 100;
        this.bold = false;
        this.italic = false;
        this.underline = false;
        this.strikeOut = false;
    }
}
exports.FontOptions = FontOptions;
// FTControlValueDataType is for Controls which represents FT-Entries
class FTControlValueDataType {
    constructor(id = undefined, value = undefined, ceimage = undefined, softDeleted = undefined, showSoftDeletedWarning = undefined, hardDeleted = undefined, isAbstract = undefined) {
        this.id = id;
        this.value = value;
        this.ceimage = ceimage;
        this.softDeleted = softDeleted;
        this.showSoftDeletedWarning = showSoftDeletedWarning;
        this.hardDeleted = hardDeleted;
        this.isAbstract = isAbstract;
    }
    ;
    static fromJSON(json) {
        let ftControlValueDataType = new FTControlValueDataType();
        Object.assign(ftControlValueDataType, json);
        return ftControlValueDataType;
    }
}
exports.FTControlValueDataType = FTControlValueDataType;
/** Base class for all controls */
class Control {
    //#endregion MEMBER VARIABLES
    //#region CONSTRUCTOR
    constructor(prependId, typeId, mode, controlDef, controlFactory) {
        /** The control's visibility regarding dynamic invisible fields */
        this.visibleDynamic = true;
        /** The control's initial referenced FT-Entries which are softdeleted, harddeleted and so on... */
        this.initialFTEntries = new Instance_1.Instance.FTEntries();
        /** The control's HTML tag */
        this.tag = "div";
        /** Hardcoded, override CSS styles that may be added to the control's DOM element */
        this.overrideCSS = {};
        /** Hardcoded, override HTML attributes that may be added to the control's DOM element */
        this.overrideAttributes = {};
        /** CSS classes for this control's DOM element */
        this.cssClasses = [];
        /** Hardcoded HTML that may be appended to the control's DOM */
        this.append = "";
        /** Hardcoded HTML that may be prepended to the control's DOM */
        this.prepend = "";
        // Liefert die Abmessungen eines Controls auch dann, wenn es gerade unsichtbar ist.
        this.getHiddenDimensions = function ($item, includeMargin) {
            let props = { position: 'absolute', visibility: 'hidden', display: 'block' };
            let dim = { width: 0, height: 0, innerWidth: 0, innerHeight: 0, outerWidth: 0, outerHeight: 0 };
            let $hiddenParents = $item.parents().addBack().not(':visible');
            let oldProps = [];
            includeMargin = (includeMargin == undefined) ? false : includeMargin;
            $hiddenParents.each(function () {
                let old = {};
                for (let name in props) {
                    old[name] = this.style[name];
                    this.style[name] = props[name];
                }
                oldProps.push(old);
            });
            dim.width = $item.width();
            dim.outerWidth = $item.outerWidth(includeMargin);
            dim.innerWidth = $item.innerWidth();
            dim.height = $item.height();
            dim.innerHeight = $item.innerHeight();
            dim.outerHeight = $item.outerHeight(includeMargin);
            $hiddenParents.each(function (i) {
                let old = oldProps[i];
                for (let name in props)
                    this.style[name] = old[name];
            });
            return dim;
        };
        if (controlDef.overrideId)
            this.id = (prependId + controlDef.overrideId);
        else
            this.id = (prependId + controlDef.key).replace(/\./g, "_");
        this.typeId = typeId;
        this.mode = mode;
        this.key = controlDef.key;
        this.width = controlDef.width;
        this.height = controlDef.height;
        this.left = controlDef.left;
        this.top = controlDef.top;
        this.visibleDynamic = controlDef.visibleDynamic;
        this.type = controlDef.type;
        this.enabled = controlDef.enabled;
        this.readonly = controlDef.readonly;
        this.readonlyForExtInput = controlDef.readonlyForExtInput;
        this.tabOrder = controlDef.tabOrder;
        this.controlFactory = controlFactory;
        this.forExternalInput = controlDef.forExternalInput || false;
        if ((controlDef.fontheight) || (controlDef.fontbold) || (controlDef.fontitalic) || (controlDef.fontunderline) || (controlDef.fontstrikeout)) {
            this.fontOptions = new FontOptions();
            if (controlDef.fontheight)
                this.fontOptions.height = controlDef.fontheight;
            if (controlDef.fontbold)
                this.fontOptions.bold = controlDef.fontbold;
            if (controlDef.fontitalic)
                this.fontOptions.italic = controlDef.fontitalic;
            if (controlDef.fontunderline)
                this.fontOptions.underline = controlDef.fontunderline;
            if (controlDef.fontstrikeout)
                this.fontOptions.strikeOut = controlDef.fontstrikeout;
        }
    }
    //#endregion CONSTRUCTOR
    //#region MEMBER METHODS
    /** Returns all override CSS properties in an object */
    getCSS() {
        let returnCSS = $.extend({}, this.overrideCSS);
        if (this.fontOptions) {
            if (this.fontOptions.height)
                returnCSS = $.extend({ "font-size": this.fontOptions.height + "%" }, returnCSS);
            if (this.fontOptions.bold)
                returnCSS = $.extend({ "font-weight": "bold" }, returnCSS);
            if (this.fontOptions.italic)
                returnCSS = $.extend({ "font-style": "italic" }, returnCSS);
            if ((this.fontOptions.underline) && (this.fontOptions.strikeOut)) {
                returnCSS = $.extend({ "text-decoration": "underline line-through" }, returnCSS);
            }
            else {
                if (this.fontOptions.underline)
                    returnCSS = $.extend({ "text-decoration": "underline" }, returnCSS);
                if (this.fontOptions.strikeOut)
                    returnCSS = $.extend({ "text-decoration": "line-through" }, returnCSS);
            }
        }
        return returnCSS;
    }
    /** Returns all override HTML attributes in an object */
    getAttributes() {
        return $.extend({ id: this.id }, this.overrideAttributes);
    }
    /** Returns a new jQuery object of the control's DOM representation */
    tojQuery() {
        let jq = $("<" + this.tag + "></" + this.tag + ">")
            .css(this.getCSS())
            .attr(this.getAttributes())
            .addClass(this.cssClasses.join(" "));
        return jq.append($(this.append))
            .prepend($(this.prepend))
            .data("control", this);
    }
    /** Returns the DOM control element for this control as jQuery object */
    getDOMControl() {
        return $("#" + this.id);
    }
    /** Returns the input DOM control element for this control as jQuery object, if the input exists. Else, returns empty selector. */
    getInputControl() {
        return $();
    }
    /** Enables/disables the control */
    enable(enable) {
        this.enabled = enable;
    }
    /** Additional code for destruction of this control, if necessary */
    destroy() {
    }
    /** SVG Helper function, since plain jquery creation of SVG elements
    *   does not work. jQuery internally uses document.createElement(), but for
    *   svg items, we need document.createElementNS() */
    SVG(tag) {
        return document.createElementNS('http://www.w3.org/2000/svg', tag);
    }
    /** Applies a PropertyPage layout mode to the control */
    setLayout(layout) {
        this.layout = layout;
        let strDisplay = "";
        let newOpacity = "";
        if (!this.visibleDynamic) {
            strDisplay = "none";
            newOpacity = "0";
        }
        if (layout === "absolute") {
            this.getDOMControl().css({
                width: this.width + "px",
                height: this.height + "px",
                top: this.top + "px",
                left: this.left + "px",
                position: "absolute",
                opacity: newOpacity,
                display: strDisplay,
            });
        }
        else {
            this.getDOMControl().css({
                width: "",
                top: "",
                left: "",
                position: "",
                opacity: newOpacity,
                display: strDisplay,
            });
            let tdParent = this.getDOMControl().parent();
            if (tdParent) {
                if (this.visibleDynamic)
                    tdParent.removeClass("ppInvisibleDynamic").addClass("ppVisibleDynamic");
                else
                    tdParent.removeClass("ppVisibleDynamic").addClass("ppInvisibleDynamic");
            }
        }
    }
    setLayoutAnimated(layout) {
        let animationDuration = gl_animationDuration;
        this.layout = layout;
        let strDisplay = "";
        let newOpacity = "";
        if (!this.visibleDynamic) {
            strDisplay = "none";
            newOpacity = "0";
        }
        let controlToAnimate = this.getDOMControl();
        if (layout === "absolute") {
            if (newOpacity == "0") {
                // Fade out
                controlToAnimate.animate({
                    width: this.width + "px",
                    height: this.height + "px",
                    top: this.top + "px",
                    left: this.left + "px",
                    opacity: newOpacity,
                }, {
                    duration: animationDuration,
                    complete() {
                        controlToAnimate.css({
                            position: "absolute",
                            display: strDisplay,
                        });
                    }
                });
            }
            else {
                // Fade in
                controlToAnimate.css({
                    position: "absolute",
                    display: strDisplay,
                });
                controlToAnimate.animate({
                    width: this.width + "px",
                    height: this.height + "px",
                    top: this.top + "px",
                    left: this.left + "px",
                    opacity: "1",
                }, {
                    duration: animationDuration,
                    // complete ist an dieser Stelle notwendig, wenn der Benutzer ein Triggerfeld sehr schnell hintereinander betätigt,
                    // sodass die Animation im Fade-out-Bereich noch nicht fertig ist. In diesem Fall könnte ein Control dort fälschlicherweise am Ende der Animation
                    // auf display=none geschaltet werden, obwohl es nach dem letzten Klick des Benutzers eigentlich sichtbar sein müsste.
                    complete() {
                        controlToAnimate.css({
                            position: "absolute",
                            display: strDisplay,
                            opacity: newOpacity // Hier wird auf alle Fälle der Default-Wert von opacity wiederhergestellt, auch wenn er von 1 abweicht, da hier newOpacity==""
                        });
                    }
                });
            }
        }
        else
            this.setLayout(layout);
    }
    applyLayoutAnimated(bApplyTop, top, bApplyHeight, height, bApplyVisibleDynamic, visibleDynamic) {
        let bLayoutChanged = false;
        if (bApplyTop) {
            if (this.top !== top) {
                this.top = top;
                bLayoutChanged = true;
            }
        }
        if (bApplyHeight) {
            if (this.height !== height) {
                this.height = height;
                bLayoutChanged = true;
            }
        }
        if (bApplyVisibleDynamic) {
            if (this.visibleDynamic !== visibleDynamic) {
                this.visibleDynamic = visibleDynamic;
                bLayoutChanged = true;
            }
        }
        if (bLayoutChanged) {
            // Das folgende wird zwar nun durch eine Absicherung in setLayoutAnimated verhindert, ist jedoch
            // korrekterweise wie folgt zu implementieren:
            // Je Control darf setLayoutAnimated nur einmal aufgerufen werden, da ansonsten das Control fälschlicherweise
            // unsichtbar werden kann, da die Animation, die das Control auf unsichtbar schaltet, zuletzt fertig wird.
            this.setLayoutAnimated(this.layout);
        }
    }
}
exports.Control = Control;
/** Base class for all field-carrying controls (i.e. everything except adorner controls such as LineControl) */
class FieldControl extends Control {
    //#endregion MEMBER VARIABLES
    //#region CONSTRUCTOR
    constructor(prependId, typeId, mode, controlDef, controlFactory) {
        super(prependId, typeId, mode, controlDef, controlFactory);
        /** Controls this control depends on */
        this.parentControls = [];
        /** Controls depending on this control */
        this.childControls = [];
        /** If there are several controls representative of a field in the PropertyPage, this collection contains all other representative controls (except this control) */
        this.otherRepresentativeControls = [];
        /** Whether this control needs a value or not */
        this.mandatory = false;
        this.field = controlDef.field;
        if (controlDef.formatString)
            this.formatString = controlDef.formatString;
        if (typeof controlDef.tabOrder !== "undefined")
            this.overrideAttributes.tabindex = controlDef.tabOrder.toString();
        this.hardDeletedFormatString = controlDef.hardDeletedFormatString;
        this.toolTip = controlDef.toolTip;
        if (this.readonly)
            this.cssClasses.push("ppReadOnly");
        if (this.toolTip && this.controlFactory.options.tooltips)
            for (let prop in this.controlFactory.options.tooltips)
                if (this.controlFactory.options.hasOwnProperty("tooltips"))
                    this.toolTip[prop] = this.controlFactory.options.tooltips[prop];
        this.cssClasses.push("ppFieldControl");
    }
    get isEmpty() {
        let bReturn = true;
        let value = this.getValue();
        if (value != undefined) {
            if (Array.isArray(value)) {
                bReturn = value.length == 0;
            }
            else {
                bReturn = value.toString() == "";
            }
        }
        return bReturn;
    }
    //#endregion CONSTRUCTOR
    //#region MEMBER METHODS
    /** Highlight this control if it is mandatory, but does not currently carry a value */
    highlightIfMandatoryAndEmpty() {
        $("#" + this.id).removeClass("ppMandatory");
        if (this.mandatory) {
            let hasValue = !this.isEmpty;
            if (this.field.isFTRepresentativeField && !hasValue) {
                let inst = this.controlFactory.getCurrentInstance();
                let hasPresentedValue = inst.items[this.field.presentedField].multiValue ?
                    inst.items[this.field.presentedField].valueAsArray.length > 0 : inst.items[this.field.presentedField].value != undefined;
                if (!hasPresentedValue)
                    $("#" + this.id).addClass("ppMandatory");
            }
            else if (!hasValue)
                $("#" + this.id).addClass("ppMandatory");
        }
    }
    /** Set the mandatory state of this control */
    setMandatory(mandatory) {
        this.mandatory = mandatory;
        this.highlightIfMandatoryAndEmpty();
    }
    /** Calls the applyToolTipCore function, can be overridden */
    applyToolTip(toolTipObj, jQueryElem) {
        const that = this;
        that.applyToolTipCore(toolTipObj, jQueryElem);
    }
    /** Apply a tooltip */
    applyToolTipCore(toolTipObj, jQueryElem) {
        const that = this;
        if (jQueryElem)
            jQueryElem.kendoTooltip(toolTipObj);
        else
            $("#" + that.id).kendoTooltip(toolTipObj);
    }
    init(jQueryElem) {
    }
    lateInit(jqueryElem) {
        const that = this;
        if (that.toolTip) {
            kendo.ui.Tooltip.fn._mouseleave = function (e) {
                window.clearTimeout(this.timeout);
            };
            let template = kendo.template('<div class="synTooltip"><div class="header">#=header#</div><div><br><br></div>#if(body){#<div class="text">#=body#</div><div><br></div>#}#</div>');
            let $result = $(template(that.toolTip));
            $result.find("a").each((i, a) => { $(a).attr("target", "_blank"); });
            let result = $result[0].outerHTML;
            that.toolTipObj = {
                content: result,
                width: 260,
                showAfter: 750,
                position: "bottom",
                autoHide: true,
                show(e) {
                    let elem = e.sender.popup.element;
                    let tooltip = this;
                    // keep open
                    tooltip.target().add(elem).off("mouseenter.tooltip").on("mouseenter.tooltip", function () {
                        elem.attr("data-keepopen", "yes");
                    });
                    tooltip.target().add(elem).off("mouseleave.tooltip").on("mouseleave.tooltip", function () {
                        elem.removeAttr("data-keepopen");
                        window.setTimeout(function () {
                            if (!elem.attr("data-keepopen")) {
                                elem.removeAttr("data-keepopen");
                                tooltip.hide();
                            }
                        }, 500);
                    });
                    // hide on mousclick
                    document.addEventListener("click", function () {
                        elem.removeAttr("data-keepopen");
                        tooltip.hide();
                    });
                    // hide on input
                    document.addEventListener('keydown', function () {
                        elem.removeAttr("data-keepopen");
                        tooltip.hide();
                    });
                }
            };
            that.applyToolTip(that.toolTipObj, jqueryElem);
        }
    }
    destroy() {
        if ($("#" + this.id).data("kendoToolTip"))
            $("#" + this.id).data("kendoToolTip").destroy();
    }
    /** Notifies the control of eventual changes. */
    notifyChange() {
        this.highlightIfMandatoryAndEmpty();
    }
    /** Notifies child and parent controls of this control of eventual changes */
    notifyDependentControls() {
        const that = this;
        if (!that.forExternalInput) {
            $.each(that.parentControls, (idx, parentControl) => {
                if (parentControl !== that)
                    parentControl.notifyChange();
            });
            $.each(that.otherRepresentativeControls, (idx, otherControl) => {
                if (otherControl !== that)
                    otherControl.notifyChange();
            });
            $.each(that.childControls, (idx, childControl) => {
                if (childControl !== that)
                    childControl.notifyChange();
            });
        }
    }
    /**
    * Converts a value of the type the control internally uses to its string representation
    *
    * @param value Value to convert
    * @param innerValue If true, value is considered atomic. Otherwise, if control is multivalue, value might be an array
    */
    convert(value, innerValue = false) {
        const that = this;
        let formatString;
        if (that instanceof AbstractFormatStringControl)
            formatString = that.formatString;
        else if (that instanceof TextBoxControl)
            formatString = that.formatString;
        return FieldControl.convertCore(value, that.field.fieldType, that.field.multiValue && !that.field.treatAsSingleValue, innerValue, that.mode, formatString);
    }
    /**
    * Converts a value's string representation to the type the control internally uses.
    *
    * @param convertedValue Value to convert, supplied as string representation
    * @param innerValue If true, value is considered atomic. Otherwise, if control is multivalue, value might be an array
    */
    convertBack(convertedValue, innerValue = false) {
        const that = this;
        if (that.mode === Base_1.PropertyPageMode.Search) {
            if (convertedValue == undefined)
                return "";
            return convertedValue;
        }
        else {
            if (that.field.multiValue && !that.field.treatAsSingleValue && !innerValue) {
                if ((convertedValue == undefined) || (convertedValue === ""))
                    return [];
                let spl = convertedValue.split(";");
                let convertedArr = [];
                for (let i = 0; i < spl.length; i++)
                    convertedArr[i] = that.convertBack(spl[i], true);
                return convertedArr;
            }
            else {
                if ((convertedValue == undefined) || (convertedValue === ""))
                    return undefined;
                let formatString = "";
                let bUseDefaultFormat = true;
                if (that instanceof AbstractFormatStringControl) {
                    formatString = that.formatString;
                    bUseDefaultFormat = false;
                }
                else if (that instanceof TextBoxControl) {
                    // Damit auch readonly Date-, Time- und DateTime-Felder korrekt formatiert dargestellt werden
                    formatString = that.formatString;
                    bUseDefaultFormat = false;
                }
                switch (that.field.fieldType) {
                    case "Date":
                        if (bUseDefaultFormat)
                            formatString = "d";
                        return kendo.parseDate(convertedValue, formatString);
                    case "DateTime":
                        if (bUseDefaultFormat)
                            formatString = "G";
                        return kendo.parseDate(convertedValue, formatString);
                    case "Time":
                        if (bUseDefaultFormat)
                            formatString = "T";
                        return kendo.parseDate(convertedValue, formatString);
                    case "Float":
                        if (bUseDefaultFormat)
                            formatString = "n2";
                        return kendo.parseFloat(convertedValue, formatString);
                    case "Digit":
                    case "BigDigit":
                        return parseInt(convertedValue, 10);
                    case "Bool":
                        return convertedValue === "Y";
                    default:
                        return convertedValue;
                }
            }
        }
    }
    /**
   * Core helper for control value conversion. Converts a value to its string representation based on fieldType, multiValue etc.
   *
   * @param value Value to convert
   * @param fieldType Type of the field
   * @param multiValue Whether the control is multivalue
   * @param innerValue If true, value is considered atomic. Otherwise, if control is multivalue, value might be an array
   * @param mode PropertyPage mode for which to convert value
   * @param formatString Optional format string that might affect conversion
   */
    static convertCore(value, fieldType, multiValue, innerValue, mode, formatString) {
        if (!value && value !== 0)
            return "";
        if (multiValue && !innerValue) {
            let mvArr = Array();
            if (typeof value === "string")
                mvArr.push(value);
            else
                mvArr = value;
            let built = "";
            $.each(mvArr, (idx, val) => {
                if (idx > 0)
                    built += ";";
                built += FieldControl.convertCore(val, fieldType, multiValue, true, mode, formatString);
            });
            return built;
        }
        else {
            switch (fieldType) {
                case "Date":
                    return kendo.toString(value, formatString || "d");
                case "DateTime":
                    return kendo.toString(value, formatString || "G");
                case "Time":
                    return kendo.toString(value, formatString || "T");
                case "Bool":
                    return (value ? "Y" : "N");
                case "Float":
                    return kendo.toString(value, formatString || "n2");
                case "Digit":
                case "BigDigit":
                default:
                    return value.toString();
            }
        }
    }
}
exports.FieldControl = FieldControl;
class TextBoxControl extends FieldControl {
    constructor(prependId, typeId, mode, controlDef, controlFactory) {
        super(prependId, typeId, mode, controlDef, controlFactory);
        this.overrideAttributes["data-fieldname"] = controlDef.field.fieldName;
        this.autoWrap = controlDef.autoWrap;
        this.multiLine = controlDef.multiLine;
        this.maxTextLength = controlDef.maxTextLength;
        this.hyperlinksEnabled = controlDef.hyperlinksEnabled;
        this.overrideAttributes.type = "text";
        this.cssClasses.push("ppInput");
        this.cssClasses.push("ppTextBox");
        this.cssClasses.push("k-textbox");
        if (this.readonly)
            this.overrideAttributes.readonly = "readonly";
        if (this.maxTextLength > 0 && !this.field.multiValue)
            this.overrideAttributes.maxlength = this.maxTextLength.toString();
        if (this.multiLine) {
            this.tag = "textarea";
            if (this.autoWrap)
                this.overrideAttributes.wrap = "soft";
            else
                this.overrideAttributes.wrap = "off";
            this.overrideCSS.resize = "none";
        }
        else {
            this.tag = "input";
            this.overrideCSS = { padding: "0" };
        }
    }
    // For multiline, multivalue controls, string must be split
    convert(value, innerValue = false) {
        let s = super.convert(value, innerValue);
        if (this.multiLine && this.field.multiValue && !this.field.treatAsSingleValue)
            return s.replace(/;/g, "\n");
        return s;
    }
    convertBack(convertedValue, innerValue = false) {
        let conv = convertedValue;
        if (this.multiLine) {
            if (this.field.multiValue && !this.field.treatAsSingleValue)
                conv = conv.replace(/\r?\n/g, ";");
            else
                conv = conv.replace(/\n/g, "\r\n");
        }
        let s = super.convertBack(conv, innerValue);
        if (this.hyperlinksEnabled && !innerValue && this.mode !== Base_1.PropertyPageMode.Search)
            this._checkLinkButton(s);
        return s;
    }
    // Change control's value after the fact!
    setValue(valueInput) {
        const that = this;
        let value = valueInput;
        that.originalValue = value;
        that.unchanged = true;
        let jq = $("#" + this.id);
        if (this.mode === Base_1.PropertyPageMode.Search)
            jq.val(value.toString());
        else
            jq.val(this.convert(value));
        if (that.hyperlinksEnabled && this.mode !== Base_1.PropertyPageMode.Search)
            that._checkLinkButton(value);
        that.highlightIfMandatoryAndEmpty();
        if (!(that.mode === Base_1.PropertyPageMode.Search) && that.initialValue) {
            if (that.initialFTEntries.hardDeletedEntries || that.initialFTEntries.softDeletedEntries || that.initialFTEntries.abstractEntries) {
                let divValue = value;
                // Do the conversion before adding html code (spans with classes) to avoid converting wrong values at the end
                let convertedString = this.convert(divValue);
                if (this.multiLine && this.field.multiValue && !this.field.treatAsSingleValue)
                    divValue = convertedString.split(/\r?\n/);
                else
                    divValue = convertedString.split(";");
                for (let i = 0; i < divValue.length; i++)
                    divValue[i] = kendo.htmlEncode(divValue[i].toString());
                let instance = that.controlFactory.getCurrentInstance();
                let jqDiv = $("#" + this.id + "_div");
                if (instance.items[that.field.presentedField].valueIsArray) {
                    // Multivalue-Fall
                    let presentedFieldValue = instance.items[that.field.presentedField].valueAsStringArray; // Hinweis: FTKeys sind immer Strings!
                    if (that.initialFTEntries.hardDeletedEntries && that.initialFTEntries.hardDeletedEntries.length > 0) {
                        jqDiv.addClass("ppHardDeletedField");
                        let delId;
                        let delIdIdx;
                        for (let i = -1, len = that.initialFTEntries.hardDeletedEntries.length; ++i < len;) {
                            delId = that.initialFTEntries.hardDeletedEntries[i];
                            delIdIdx = _.indexOf(presentedFieldValue, delId);
                            if (delIdIdx >= 0) {
                                divValue.splice(delIdIdx, 0, kendo.format(Utilities_1.synUtil.Strings.getValue("dynpftentryharddeletedid").replace('%s', '{0}'), delId));
                                divValue[delIdIdx] = "<span class=\"ppFtHardDeletedEntry\">" + divValue[delIdIdx] + "</span>";
                            }
                        }
                        if (_.intersection(presentedFieldValue, that.initialFTEntries.hardDeletedEntries).length === 0)
                            jqDiv.removeClass("ppHardDeletedField");
                    }
                    if (that.initialFTEntries.softDeletedEntries && that.initialFTEntries.softDeletedEntries.length > 0) {
                        jqDiv.addClass("ppSoftDeletedField");
                        let delId;
                        let delIdIdx;
                        let softDeletedEntriesIDs = _.pluck(that.initialFTEntries.softDeletedEntries, 'id');
                        for (let i = -1, len = that.initialFTEntries.softDeletedEntries.length; ++i < len;) {
                            delId = softDeletedEntriesIDs[i];
                            delIdIdx = _.indexOf(presentedFieldValue, delId);
                            if (delIdIdx >= 0 && that.initialFTEntries.softDeletedWarningEntries
                                && that.initialFTEntries.softDeletedWarningEntries
                                && $.inArray(delId, that.initialFTEntries.softDeletedWarningEntries) >= 0) {
                                divValue[delIdIdx] = "<span class=\"ppFtSoftDeletedEntry\" title=\"" + Utilities_1.synUtil.Strings.getValue("deleteobjsoft") + "\">" + divValue[delIdIdx] + "</span>";
                            }
                        }
                        if (_.intersection(presentedFieldValue, softDeletedEntriesIDs).length === 0)
                            jqDiv.removeClass("ppSoftDeletedField");
                    }
                    if (that.initialFTEntries.abstractEntries && that.initialFTEntries.abstractEntries.length > 0) {
                        jqDiv.addClass("ppAbstractField");
                        let abstractId;
                        let abstractIdIdx;
                        let abstractEntriesIDs = _.pluck(that.initialFTEntries.abstractEntries, 'id');
                        for (let i = -1, len = that.initialFTEntries.abstractEntries.length; ++i < len;) {
                            abstractId = abstractEntriesIDs[i];
                            abstractIdIdx = _.indexOf(presentedFieldValue, abstractId);
                            if (abstractIdIdx >= 0 && that.initialFTEntries.abstractEntries)
                                divValue[abstractIdIdx] = "<span class=\"ppFtAbstractEntry\" title=\"" + kendo.format(Utilities_1.synUtil.convertFormatString(Utilities_1.synUtil.Strings.getValue("dynpftentryabstract")), divValue[abstractIdIdx]) + "\">" + divValue[abstractIdIdx] + "</span>";
                        }
                        if (_.intersection(presentedFieldValue, abstractEntriesIDs).length === 0)
                            jqDiv.removeClass("ppAbstractField");
                    }
                }
                else {
                    // SingleValue-Fall
                    let presentedFieldValue = instance.items[that.field.presentedField].valueAsString; // Hinweis: FTKeys sind immer Strings!
                    if (that.initialFTEntries.hardDeletedEntries && that.initialFTEntries.hardDeletedEntries.length > 0) {
                        if (that.initialFTEntries.hardDeletedEntries.indexOf(presentedFieldValue) != -1) {
                            jqDiv.addClass("ppHardDeletedField");
                            divValue.splice(0, 0, kendo.format(Utilities_1.synUtil.Strings.getValue("dynpftentryharddeletedid").replace('%s', '{0}'), presentedFieldValue));
                            divValue[0] = "<span class=\"ppFtHardDeletedEntry\">" + divValue[0] + "</span>";
                        }
                    }
                    if (that.initialFTEntries.softDeletedEntries && that.initialFTEntries.softDeletedEntries.length > 0) {
                        let softDeletedEntriesIDs = _.pluck(that.initialFTEntries.softDeletedEntries, 'id');
                        if (softDeletedEntriesIDs.indexOf(presentedFieldValue) != -1) {
                            jqDiv.addClass("ppSoftDeletedField");
                            if (that.initialFTEntries.softDeletedWarningEntries
                                && $.inArray(presentedFieldValue, that.initialFTEntries.softDeletedWarningEntries) >= 0) {
                                divValue[0] = "<span class=\"ppFtSoftDeletedEntry\" title=\"" + Utilities_1.synUtil.Strings.getValue("deleteobjsoft") + "\">" + divValue[0] + "</span>";
                            }
                        }
                    }
                    if (that.initialFTEntries.abstractEntries && that.initialFTEntries.abstractEntries.length > 0) {
                        let abstractEntriesIDs = _.pluck(that.initialFTEntries.abstractEntries, 'id');
                        if (abstractEntriesIDs.indexOf(presentedFieldValue) != -1) {
                            jqDiv.addClass("ppAbstractField");
                            divValue[0] = "<span class=\"ppFtAbstractEntry\" title=\"" + kendo.format(Utilities_1.synUtil.convertFormatString(Utilities_1.synUtil.Strings.getValue("dynpftentryabstract")), divValue[0]) + "\">" + divValue[0] + "</span>";
                        }
                    }
                }
                // Join the array again based on rules used in the convert function
                let divValueString = "";
                if (this.multiLine && this.field.multiValue && !this.field.treatAsSingleValue) {
                    divValueString = divValue.join("\n");
                    jqDiv.css("white-space", "pre");
                }
                else
                    divValueString = divValue.join(";");
                jqDiv.html(divValueString);
            }
        }
    }
    getValue() {
        if (this.unchanged)
            return this.originalValue;
        return this.convertBack($("#" + this.id).val());
    }
    setFocus() {
    }
    getInputControl() {
        return this.getDOMControl();
    }
    init(jqueryElem) {
        super.init(jqueryElem);
        const that = this;
        if (!(that.mode === Base_1.PropertyPageMode.Search) && that.initialValue && (that.initialFTEntries.hardDeletedEntries || that.initialFTEntries.softDeletedEntries || that.initialFTEntries.abstractEntries)) {
            let overflow = that.multiLine ? "auto" : "hidden";
            $('<div class="k-input ppInput ppReadOnly" id="' + that.id + '_div"></div>').css({
                "padding": "3px",
                "overflow": overflow,
                "white-space": "nowrap",
                "margin": 0,
                width: (this.width - 8) + "px",
                height: (this.height - 8) + "px",
                top: (this.top + 1) + "px",
                left: (this.left + 1) + "px",
                position: "absolute",
                "z-index": "1000"
            })
                .appendTo(jqueryElem.parent());
        }
        if (that.hyperlinksEnabled && that.mode !== Base_1.PropertyPageMode.Search) {
            let hyperlinkBtn = $("<button type='button' class='btn btn-default'  id='btnDefault_" + that.id + "'><i class='fa fa-external-link'></i></button>")
                .css({
                "background-position": "50% 50%",
                "background-repeat": "no-repeat",
                "border-radius": "0px",
                "padding": 0,
                "margin": 0,
                width: "20px",
                height: (this.height - 2) + "px",
                top: this.top + "px",
                left: (this.left + this.width - 22) + "px",
                position: "absolute"
            })
                .appendTo(jqueryElem.parent());
            this.width = this.width - 25;
            hyperlinkBtn.on("click", function (e) {
                let windowData = Utilities_1.synUtil.popupWindow({
                    title: 'Hyperlinks',
                    width: 425,
                    height: 120,
                    modal: true
                });
                let linkArray = Utilities_1.synUtil.extractLinks(that.getValue());
                let windowDiv = $('<div id="winDiv_' + windowData.guid + '" style="height: 100%; overflow: auto; white-space: nowrap;"></div>');
                if (linkArray) {
                    for (let i = -1, len = linkArray.length; ++i < len;) {
                        let normalized = linkArray[i];
                        if (/^www\./i.test(normalized))
                            normalized = "http://" + normalized;
                        let link = $("<a></a>").text(linkArray[i])
                            .appendTo(windowDiv);
                        $("<br />").appendTo(windowDiv);
                        if (/^ris/i.test(normalized))
                            link.attr("href", "javascript:void(0)")
                                .on("click", (evt) => {
                                that.executeRisLink($(evt.target).text());
                            });
                        else
                            link.attr({
                                "target": "_blank",
                                "rel": "noopener noreferrer",
                                "href": normalized
                            });
                    }
                }
                windowDiv.appendTo(windowData.contentDiv);
            });
        }
        if (that.initialValue != undefined && !that.forExternalInput)
            that.setValue(that.initialValue);
        that.updateIcon();
    }
    tojQuery() {
        const that = this;
        let jq = $("<" + that.tag + "></" + that.tag + ">")
            .css(that.getCSS())
            .attr(that.getAttributes())
            .addClass(that.cssClasses.join(" "))
            .data("control", that);
        if (!that.forExternalInput)
            jq.val(that.convert(that.initialValue));
        jq.on("input", Utilities_1.synUtil.throttleFunction(() => {
            that.unchanged = false;
            that.highlightIfMandatoryAndEmpty();
            that.controlFactory.raiseOnChange(that.controlFactory, true);
        }, 250));
        // handle focus
        jq.on("focus", () => {
            that.controlFactory.raiseOnRequestExtendedSearchButton(that);
        });
        // handle blur
        jq.on("blur", () => {
            that.controlFactory.raiseOnDisposeExtendedSearchButton(that);
        });
        // Handle Enter as search command in search mode
        if (that.mode === Base_1.PropertyPageMode.Search) {
            jq.on("keyup", (e) => {
                if (!that.readonly && e.which === 13)
                    that.controlFactory.raiseOnSearch(that.controlFactory);
            });
            // Prevent inserting newlines via Enter in multiline textboxes in search mode
            if (that.multiLine) {
                jq.on("keydown", (e) => {
                    if (!that.readonly && e.which === 13) {
                        e.preventDefault();
                        return false;
                    }
                });
            }
        }
        return jq;
    }
    enable(enable) {
        super.enable(enable);
        Utilities_1.synUtil.toggleEnabledState($("#" + this.id), enable);
    }
    executeRisLink(link) {
        let bWrongFormat = false;
        let strDBName;
        let strDB;
        let strGSNr;
        let selDate;
        link = link.toLowerCase();
        if (link.indexOf("ris://") === -1)
            bWrongFormat = true;
        else {
            let idx = link.lastIndexOf(":");
            strGSNr = link.substring(idx + 1);
            if (link.indexOf("bg") !== -1) {
                strDBName = "Bundesgesetz";
                strDB = "Bundesnormen";
            }
            else if (link.indexOf("lg_b") !== -1) {
                strDBName = "Burgenland";
                strDB = "LrBgld";
            }
            else if (link.indexOf("lg_k") !== -1) {
                strDBName = "Kärnten";
                strDB = "LrK";
            }
            else if (link.indexOf("lg_n") !== -1) {
                strDBName = "Niederösterreich";
                strDB = "LrNo";
            }
            else if (link.indexOf("lg_o") !== -1) {
                strDBName = "Oberösterreich";
                strDB = "LrOO";
            }
            else if (link.indexOf("lg_s") !== -1) {
                strDBName = "Salzburg";
                strDB = "LrSbg";
            }
            else if (link.indexOf("lg_st") !== -1) {
                strDBName = "Steiermark";
                strDB = "LrStmk";
            }
            else if (link.indexOf("lg_t") !== -1) {
                strDBName = "Tirol";
                strDB = "LrT";
            }
            else if (link.indexOf("lg_v") !== -1) {
                strDBName = "Vorarlberg";
                strDB = "LrVbg";
            }
            else if (link.indexOf("lg_w") !== -1) {
                strDBName = "Wien";
                strDB = "LrW";
            }
            else
                bWrongFormat = true;
        }
        if (bWrongFormat) {
            //Error
            $.errorDialog({
                ErrorDisplayMessage: Utilities_1.synUtil.Strings.getValue("synerisrisdlgerrorurl")
            });
        }
        else {
            let action = Utilities_1.synUtil.Strings.getValue("synerisrisdlgcaption");
            let windowsDataTemp = Utilities_1.synUtil.popupWindow({
                title: action,
                width: 350,
                height: 175,
                modal: true
            });
            let windowid = "popup_" + windowsDataTemp.guid;
            let data = {
                synUtil: Utilities_1.synUtil,
                windowID: "popup_" + windowsDataTemp.guid,
                buttonID: "button_" + windowsDataTemp.guid,
                cancelButtonID: "cancelButton_" + windowsDataTemp.guid,
                risDB: "database_" + windowsDataTemp.guid,
                risVersion: "version_" + windowsDataTemp.guid,
                synerisRisCheckBoxVersion: "versioncheckbox_" + windowsDataTemp.guid,
                synerisRisCheckTargetDate: "datecheckbox_" + windowsDataTemp.guid,
                synerisRisDatePicker: "datepicker_" + windowsDataTemp.guid,
                buttonText: kendo.htmlEncode(Utilities_1.synUtil.Strings.getValue("menuok"))
            };
            //Create HTML from template
            let template = kendo.template(risLinkMarkup);
            windowsDataTemp.contentDiv.html(template(data));
            $("#" + data.cancelButtonID).on("click", function () {
                $("#" + windowid).data("kendoWindow").close();
            });
            selDate = new Date();
            $("#" + data.synerisRisDatePicker).kendoDatePicker({
                format: "d",
                value: new Date(),
                change() {
                    selDate = this.value();
                }
            });
            $("#" + data.risDB).val(strDBName);
            $("#" + data.risVersion).val(strGSNr);
            $("#" + data.synerisRisCheckTargetDate).on("click", function () {
                let bChecked = $("#" + data.synerisRisCheckTargetDate).prop("checked");
                $("#" + data.synerisRisCheckBoxVersion).prop("checked", !bChecked);
                if (bChecked)
                    $("#" + data.synerisRisDatePicker).data('kendoDatePicker').enable(true);
            });
            $("#" + data.synerisRisCheckBoxVersion).on("click", function () {
                let bChecked = $("#" + data.synerisRisCheckBoxVersion).prop("checked");
                $("#" + data.synerisRisCheckTargetDate).prop("checked", !bChecked);
                if (bChecked)
                    $("#" + data.synerisRisDatePicker).data('kendoDatePicker').enable(false);
            });
            $("#" + data.buttonID).on("click", function () {
                $("#" + data.synerisRisCheckTargetDate).prop("checked");
                let bOpenUrl = true;
                let strUrl = "http://www.ris.bka.gv.at/Ergebnis.wxe?Abfrage=";
                strUrl = strUrl + strDB + "&Gesetzesnummer=" + strGSNr;
                //if checked &FassungVom= außer wien st 
                if ($("#" + data.synerisRisCheckTargetDate).prop("checked")) {
                    if (strDB === "LrW" || strDB === "LrStmk") { // error
                        bOpenUrl = false;
                        $.errorDialog({
                            ErrorDisplayMessage: Utilities_1.synUtil.Strings.getValue("synerisrisdlgerrornodateallowed")
                        });
                    }
                    else {
                        //DateFormat for ris DD.MM.YYYY
                        //DateFormat json data YYYY-MM-DD
                        let strDate = Utilities_1.synUtil.dateToJson(selDate);
                        strUrl = strUrl + "&FassungVom=";
                        let idx = strDate.indexOf("-");
                        let strYear = strDate.substring(0, idx);
                        idx = idx + 1;
                        let idx1 = strDate.indexOf("-", idx);
                        let strMonth = strDate.substring(idx, idx1);
                        let strDay = strDate.substring(idx1 + 1);
                        strUrl = strUrl + strDay + "." + strMonth + "." + strYear;
                    }
                }
                if (bOpenUrl) {
                    window.open(strUrl);
                    $("#" + data.windowID).data("kendoWindow").close();
                }
            });
        }
    }
    updateIcon() {
        if (!this.field.multiValue || this.field.treatAsSingleValue) {
            let $domCtrl = this.getDOMControl();
            if (this.iconUrl) {
                $domCtrl.css({
                    "text-indent": this.height + "px",
                    "background-image": "url('" + Utilities_1.synUtil.getWSUrl("Icon") + this.iconUrl + "/" + this.height + "')"
                });
            }
            else
                $domCtrl.css({ "text-indent": "", "background-image": "none" });
        }
    }
    _checkLinkButton(value) {
        let jqButton = $("#btnDefault_" + this.id);
        if ((Utilities_1.synUtil.extractLinks(this.convert(value))).length > 0)
            jqButton.prop('disabled', false);
        else
            jqButton.prop('disabled', true);
    }
    _protectedFetchDataCore(callback) {
        const that = this;
        let requestData = {
            paging: true,
            instance: that.controlFactory.getCurrentInstance().toJSON(),
            pageSize: 1,
            page: 1,
        };
        let val;
        if (that.controlFactory.hasWorkingValue(that.field.presentedField))
            val = that.controlFactory.getWorkingValue(that.field.presentedField, that.field.multiValue && !that.field.treatAsSingleValue);
        else
            val = that.controlFactory.getCurrentInstance().items[that.field.presentedField].value;
        let hasPresentedValue = (that.field.multiValue && !that.field.treatAsSingleValue ? val.length : val);
        if (!hasPresentedValue) {
            if (that.field.multiValue && !that.field.treatAsSingleValue)
                callback([], []);
            else
                callback(undefined, []);
            that.controlFactory.raiseOnChange(that.controlFactory, false);
        }
        else {
            let colOnly = that.field.fieldName.substring(that.field.fieldName.indexOf(".") + 1);
            Utilities_1.synUtil.getAJAXData({
                method: "POST",
                url: Utilities_1.synUtil.getWSUrl("PropertypageForeigntableentries") + that.typeId + "/" + that.mode + "/" + encodeURIComponent(that.key),
                requestData: JSON.stringify(requestData),
                done: (data) => {
                    let fixed = Utilities_1.synUtil.fixForeignTable(data, that.mode);
                    let conv = $.map(fixed.items, (elem, idx) => {
                        return {
                            id: elem.id,
                            value: elem[colOnly],
                            _icon: elem._icon
                        };
                    });
                    // Convert data: only keep currently selected ids of instance
                    let s = $.grep(conv, (e, i) => {
                        if (that.field.multiValue && !that.field.treatAsSingleValue)
                            return $.inArray(e.id, val) >= 0;
                        else
                            return e.id === val;
                    });
                    let ignoreValues = [];
                    if (that.field.multiValue && !that.field.treatAsSingleValue) {
                        for (let i = 0; i < val.length; ++i)
                            if ($.grep(s, item => item.id === val[i]).length === 0)
                                ignoreValues.push(val[i]);
                    }
                    else if (val && $.grep(s, item => item.id === val).length === 0)
                        ignoreValues.push(val);
                    // For multiValue TextBoxControls, return array of current values
                    if (that.field.multiValue && !that.field.treatAsSingleValue) {
                        s = $.map(s, (e, i) => {
                            // This is a special case where a MVFT control represents the ID field of the foreign 
                            // table. In that case, the VALUE for the representative field is the ID and since the
                            // ForeignTableEntries webservice will return the id column of an FT as STRING (as
                            // opposed to INT which would usually be the proper DB field type) for technical 
                            // reasons*), is has to be converted to the type of the control itself (which in turn
                            // derives from the DBFieldType of the underlying field, unless specified otherwise in
                            // CEFIELDDEF (which is almost always WRONG!)) - which is USUALLY INT. Otherwise we
                            // would have a field of type INT taking a value of type STRING and for later requests,
                            // the deserialization layer would try to interpret the string as int, thereby throwing 
                            // a casting error.
                            //
                            // *) The reasons are mainly that FTs may stem from external databases where the unique
                            // keys are not integers. The entire data model must account for that rare occasion and
                            // because of this, Fields of type FTKey are automatically converted to String.
                            if (that.field.isFTRepresentativeField && colOnly === "id")
                                return that.convertBack(e.value, true);
                            else
                                return e.value;
                        });
                    }
                    else {
                        // For singleValue TextBoxControls, return value (or undefined). Also, set icon for singlevalue FT
                        // textboxes (i.e. readonly FT representative fields)
                        that.iconUrl = "";
                        if (s.length) {
                            that.iconUrl = s[0]._icon;
                            s = that.convertBack(s[0].value, true);
                        }
                        else
                            s = undefined;
                    }
                    callback(s, ignoreValues);
                    that.controlFactory.raiseOnChange(that.controlFactory, false);
                }
            });
        }
    }
    notifyChange() {
        const that = this;
        that._protectedFetchDataCore((data, ignoreValues) => {
            that.setValue(data);
            if (that.field.isFTRepresentativeField) {
                let ignoredValue = false;
                if (ignoreValues.length > 0 && that.controlFactory.hasWorkingValue(that.field.presentedField)) {
                    let workingValue = undefined;
                    if (that.field.multiValue && !that.field.treatAsSingleValue) {
                        workingValue = that.controlFactory.getWorkingValue(that.field.presentedField, true);
                        if (Array.isArray(workingValue)) {
                            if (workingValue.length > 0) {
                                let corrWorkingValue = [];
                                for (let i = 0; i < workingValue.length; ++i) {
                                    if ($.inArray(workingValue[i], ignoreValues) < 0)
                                        corrWorkingValue.push(workingValue[i]);
                                }
                                if (corrWorkingValue.length < workingValue.length) {
                                    that.controlFactory.setWorkingValue(that.field.presentedField, corrWorkingValue);
                                    ignoredValue = true;
                                }
                            }
                        }
                    }
                    else {
                        if (workingValue && $.inArray(workingValue, ignoreValues) >= 0) {
                            that.controlFactory.deleteWorkingValue(that.field.presentedField);
                            ignoredValue = true;
                        }
                    }
                    if (ignoredValue) {
                        that.controlFactory.propertyPagejQuery.trigger("ignoredValue", [that.field.presentedField]);
                        that.controlFactory.notifyIgnoreField(that.field.presentedField);
                    }
                }
            }
            that.controlFactory.raiseControlChange(that);
            that.highlightIfMandatoryAndEmpty();
            that.updateIcon();
        });
    }
    setLayoutTextBoxControl(layout) {
        const that = this;
        let strDisplay = "";
        let newOpacity = "";
        if (!this.visibleDynamic) {
            strDisplay = "none";
            newOpacity = "0";
        }
        if (layout === 'table' && that.hyperlinksEnabled) {
            window.setTimeout(function () {
                // Correct Hyperlink-Buttons
                let jqButton = $("#btnDefault_" + that.id);
                let jq = $("#" + that.id);
                jqButton.appendTo(jq.parent());
                jq.css('width', (jq.outerWidth()) - 25 + "px");
                jqButton.css({
                    position: "inherit",
                    left: "",
                    top: "",
                    height: "",
                    opacity: newOpacity,
                    display: strDisplay,
                });
            }, 1000);
        }
        else if (that.hyperlinksEnabled && that.mode !== Base_1.PropertyPageMode.Search) {
            let jqButton = $("#btnDefault_" + that.id);
            jqButton.css({
                top: this.top + "px",
                opacity: newOpacity,
                display: strDisplay,
            });
        }
    }
    setLayout(layout) {
        super.setLayout(layout);
        this.setLayoutTextBoxControl(layout);
    }
    setLayoutAnimated(layout) {
        super.setLayoutAnimated(layout);
        this.setLayoutTextBoxControl(layout);
    }
}
exports.TextBoxControl = TextBoxControl;
class ButtonControl extends FieldControl {
    constructor(prependId, typeId, mode, controlDef, controlFactory) {
        super(prependId, typeId, mode, controlDef, controlFactory);
        this.text = controlDef.text;
        this.textKey = controlDef.textKey;
        this.desiredWidth = controlDef.desiredWidth;
        this.desiredHeight = controlDef.desiredHeight;
        this.cssClasses.push("ppButton");
        if ((controlDef.text === "") && (controlDef.image)) {
            this.image = Utilities_1.synUtil.getWSUrl("IconRect")
                + "resource="
                + controlDef.image.replace(/\.ico$/, "")
                + "/" + parseInt(this.desiredWidth, 10).toString()
                + "/" + parseInt(this.desiredHeight, 10).toString();
        }
        this.tag = "button";
        this.overrideCSS = {
            minWidth: "24px",
            padding: "0",
            borderWidth: "1px",
            borderRadius: "0px"
        };
    }
    setFocus() {
    }
    getValue() {
        throw new Error("Method not implemented.");
    }
    setValue(val) {
    }
    init(jqueryElem) {
        super.init(jqueryElem);
        jqueryElem.attr("type", "button");
        if (this.image) {
            jqueryElem.css({
                "background-image": "url('" + this.image + "')",
                "background-position": "50% 50%",
                "background-repeat": "no-repeat"
            });
        }
    }
    enable(enable) {
        super.enable(enable);
        Utilities_1.synUtil.toggleEnabledState($("#" + this.id), enable);
    }
    setLayoutButtonControl(layout) {
        if (layout !== "absolute")
            this.getDOMControl().css("height", "");
    }
    setLayout(layout) {
        super.setLayout(layout);
        this.setLayoutButtonControl(layout);
    }
    setLayoutAnimated(layout) {
        super.setLayoutAnimated(layout);
        this.setLayoutButtonControl(layout);
    }
    tojQuery() {
        return super.tojQuery().text(this.text);
    }
}
class MethodButtonMethod {
    constructor(name, isFTOLMethod, icon) {
        this.name = name;
        this.isFTOLMethod = isFTOLMethod;
        this.icon = icon;
    }
}
class MethodButtonControl extends ButtonControl {
    constructor(prependId, typeId, mode, controlDef, controlFactory) {
        super(prependId, typeId, mode, controlDef, controlFactory);
        this.methods = [];
        this.cssClasses.push("ppMethodButton");
        this.cssClasses.push("btn-group");
        this.tag = "div";
        for (let i = 0; i < controlDef.methods.length; i++)
            this.methods.push(controlDef.methods[i]);
        if (controlDef.text === "") {
            this.image = Utilities_1.synUtil.getWSUrl("IconRect") + controlDef.buttonIcon
                + "/" + parseInt(this.desiredWidth, 10).toString()
                + "/" + parseInt(this.desiredHeight, 10).toString();
            this.iconUrl = this.image;
        }
        else {
            this.image = undefined;
            this.text = controlDef.text;
        }
    }
    init(jqueryElem) {
        super.init(jqueryElem);
        const that = this;
        let exec = (method) => {
            let execCore = (methodId, instOrIdArray, progressTarget, ftolInfo) => {
                Utilities_1.synUtil.beginAjaxProgress(progressTarget);
                MethodManager_1.MethodManager.executeMethod(methodId, instOrIdArray, undefined, undefined, (serverExecuted) => {
                    Utilities_1.synUtil.endAjaxProgress(progressTarget);
                }, $.extend({ newWindow: true }, ftolInfo));
            };
            let progressTarget = "#btnDefault_" + that.id;
            if (method.isFTOLMethod) {
                let ftolInfo = {
                    "EXTVALUEINPUT_MULTIVALUE": that.field.multiValue ? "Y" : "N",
                    "EXTVALUEINPUT_FIELDNAME": that.field.fieldName,
                    "EXTVALUEINPUT_PAGEMODE": that.mode.toString()
                };
                if (that.field.isFTRepresentativeField)
                    ftolInfo.EXTVALUEINPUT_PRESENTEDFIELDNAME = that.field.presentedField;
                let docIdCallback = function (docId) {
                    if (docId) {
                        if (Array.isArray(docId)) {
                            if (docId.length > 0) {
                                for (let xDocId = 0; xDocId < docId.length; xDocId++) {
                                    let docidSingle = docId[xDocId];
                                    if (docidSingle) {
                                        Utilities_1.synUtil.beginAjaxProgress(progressTarget);
                                        Utilities_1.synUtil.getInstance(docidSingle.toString(), function (instance) {
                                            execCore(method.id, instance, progressTarget, ftolInfo);
                                            Utilities_1.synUtil.endAjaxProgress(progressTarget);
                                        }, function (jqXHR, textStatus, errorThrown, url) {
                                            Utilities_1.synUtil.endAjaxProgress(progressTarget);
                                            Utilities_1.synUtil.getAJAXDataFail(jqXHR, textStatus, errorThrown, url);
                                        });
                                    }
                                }
                            }
                        }
                        else {
                            Utilities_1.synUtil.beginAjaxProgress(progressTarget);
                            Utilities_1.synUtil.getInstance(docId.toString(), function (instance) {
                                execCore(method.id, instance, progressTarget, ftolInfo);
                                Utilities_1.synUtil.endAjaxProgress(progressTarget);
                            }, function (jqXHR, textStatus, errorThrown, url) {
                                Utilities_1.synUtil.endAjaxProgress(progressTarget);
                                Utilities_1.synUtil.getAJAXDataFail(jqXHR, textStatus, errorThrown, url);
                            });
                        }
                    }
                };
                // assume FT
                if (that.overrideCurrentInstanceIdFuncFTOL)
                    that.overrideCurrentInstanceIdFuncFTOL(method, that.field, docIdCallback);
                else {
                    let field = that.field.fieldName;
                    if (that.field.isFTRepresentativeField)
                        field = that.field.presentedField;
                    if (that.field.isFTField) {
                        if (method.field.length > 0) {
                            let reqIds = that.controlFactory.getCurrentInstance().items[that.field.presentedField].value;
                            if (reqIds) {
                                let ftData;
                                if (Array.isArray(reqIds))
                                    ftData = { requestedIds: reqIds };
                                else
                                    ftData = { requestedIds: [reqIds] };
                                if (ftData.requestedIds.length > 0) {
                                    Utilities_1.synUtil.getAJAXData({
                                        method: "POST",
                                        url: Utilities_1.synUtil.getWSUrl("ForeigntableEntries") + that.field.foreignTableName + "/",
                                        requestData: JSON.stringify(ftData),
                                        done(data) {
                                            for (let xDocId = 0; xDocId < data.items.length; xDocId++)
                                                docIdCallback(data.items[xDocId][method.field]);
                                        },
                                        fail(jqXHR, textStatus, errorThrown, url) {
                                            Utilities_1.synUtil.getAJAXDataFail(jqXHR, textStatus, errorThrown, url);
                                        }
                                    });
                                }
                            }
                        }
                        else
                            docIdCallback(that.controlFactory.getCurrentInstance().items[that.field.presentedField].value);
                    }
                    else
                        docIdCallback(that.controlFactory.getCurrentInstance().items[field].value);
                }
            }
            else {
                let inst = that.controlFactory.getCurrentInstance();
                // Encapsulated due to overrideCurrentInstanceFunc() being async
                let finishInit = function () {
                    let coll = that.controlFactory.controlCollection.controlsByFieldName[that.field.fieldName];
                    let externalInput = ExternalInputFactory_1.ExternalInputFactory.create(method.id, coll, inst);
                    if (externalInput) {
                        externalInput.show((cancelled, changedInstance, addlData, forceFullRefresh) => {
                            if (that.overrideExternalInputCallBack)
                                that.overrideExternalInputCallBack(cancelled, changedInstance, undefined, false);
                            else if (!cancelled) {
                                if (forceFullRefresh)
                                    that.controlFactory.raiseOnFullRefresh(that.controlFactory);
                                else {
                                    that.controlFactory.changeInstance(changedInstance);
                                    that.highlightIfMandatoryAndEmpty();
                                    that.controlFactory.raiseOnChange(that.controlFactory, false);
                                }
                            }
                        });
                    }
                    else
                        execCore(method.id, inst, progressTarget, undefined);
                };
                if (that.overrideCurrentInstanceFunc) {
                    that.overrideCurrentInstanceFunc().then((value) => {
                        inst = value;
                        finishInit();
                    });
                }
                else
                    finishInit();
            }
        };
        let m = this.methods;
        let leftPart;
        if (this.image) {
            leftPart = $("<button type='button' class='btn btn-default'  id='btnDefault_" + that.id + "'></button>")
                .css({
                "box-sizing": "border-box",
                "background-image": "url('" + this.iconUrl + "')",
                "background-position": "50% 50%",
                "background-repeat": "no-repeat",
                "border-radius": "0px",
                "height": "100%",
                "flex": "1",
            })
                .appendTo(jqueryElem);
        }
        else {
            leftPart = $("<button type='button' class='btn btn-default'  id='btnDefault_" + that.id + "'></button>")
                .css({
                "box-sizing": "border-box",
                "background-position": "50% 50%",
                "background-repeat": "no-repeat",
                "border-radius": "0px",
                "height": "100%",
                "flex": "1",
            })
                .appendTo(jqueryElem)
                .text(this.text);
        }
        if (m.length)
            leftPart.on("click", () => { exec(m[0]); });
        if (m.length > 1) {
            leftPart.addClass("splitButtonLeft");
            let rightPart = $("<div class='btn-group splitButtonRight'></div>").appendTo(jqueryElem)
                .css({
                "box-sizing": "border-box",
                "height": "100%",
                "flex": "1",
            });
            let rButton = $("<button type='button' class='btn btn-default dropdown-toggle' data-toggle='dropdown'></button")
                .css({
                "box-sizing": "border-box",
            })
                .appendTo(rightPart);
            rButton.append($("<span class='caret'></span>"));
            let ul = $("<ul class='dropdown-menu'></ul>").appendTo(rightPart);
            let iconWSUrl = Utilities_1.synUtil.getWSUrl("Icon");
            $.each(this.methods, (idx, method) => {
                let methodText = method.name;
                if (idx === 0)
                    methodText = "<strong>" + method.name + "</strong>";
                let li = $("<li></li>").appendTo(ul);
                let icon = iconWSUrl + "transparent/16";
                if (method.icon !== "0")
                    icon = iconWSUrl + "docid=" + method.icon + "/16";
                let linkHtml = $("<a href='javascript:;'>"
                    + "<img alt='" + Utilities_1.synUtil.escapeHTMLAttribute(method.name) + "' src='" + icon + "' />"
                    + methodText + "</a>")
                    .on("click", () => { exec(method); })
                    .appendTo(li);
            });
        }
        else
            leftPart.addClass("onlyButton");
    }
    tojQuery() {
        return super.tojQuery()
            .text("") // der Text stört hier. Ansonsten wird er (sofern im Layout-Editor beim Button einer eingetragen wurde und somit kein Icon angezeigt wird) doppelt angezeigt!
            .css({
            "display": "flex" // wichtig, damit die Icon- und Pfeil-Teile des Buttons "gelayoutet" werden können
        });
    }
    enable(enable) {
        this.enabled = enable;
        Utilities_1.synUtil.toggleEnabledState($("#" + this.id).children("button"), enable);
    }
}
exports.MethodButtonControl = MethodButtonControl;
class MultiValueButtonControl extends ButtonControl {
    constructor(prependId, typeId, mode, controlDef, controlFactory) {
        super(prependId, typeId, mode, controlDef, controlFactory);
        this.tag = "button";
        this.cssClasses.push("ppMVButton");
        this.cssClasses.push("btn");
        this.cssClasses.push("btn-default");
        if (controlDef.text === "") {
            this.image = Utilities_1.synUtil.getWSUrl("IconRect") + "resource=Multiline"
                + "/" + parseInt(this.desiredWidth, 10).toString()
                + "/" + parseInt(this.desiredHeight, 10).toString();
        }
        if (controlDef.methodButton)
            this.methodButtonForMVDialog = controlDef.methodButton;
    }
    init(jqueryElem) {
        super.init(jqueryElem);
        const that = this;
        jqueryElem.on("click", () => {
            let controlColl = that.controlFactory.controlCollection.controlsByFieldName[that.field.fieldName];
            let picker = new MVPicker_1.MVPicker(controlColl, that.controlFactory.getCurrentInstance());
            picker.show((cancelled, changedInstance) => {
                if (!cancelled) {
                    that.controlFactory.changeInstance(changedInstance);
                    that.controlFactory.raiseOnChange(that.controlFactory, true);
                    that.controlFactory.raiseOnFtFieldChange(that.controlFactory);
                }
            });
        });
    }
}
class DateTimeSearchButtonControl extends ButtonControl {
    constructor(prependId, typeId, mode, controlDef, controlFactory) {
        super(prependId, typeId, mode, controlDef, controlFactory);
        this.tag = "button";
        this.cssClasses.push("ppDateSearchButton");
        this.cssClasses.push("btn");
        this.cssClasses.push("btn-default");
    }
    init(jqueryElem) {
        super.init(jqueryElem);
        const that = this;
        jqueryElem.on("click", () => {
            let controlColl = that.controlFactory.controlCollection.controlsByFieldName[that.field.fieldName];
            let buttonControlDef = that.controlFactory.controlCollection.buttonControlDefsForExtendedSearch[controlColl.Input.field.fieldName] || undefined;
            let dlg = new PropertyPageExtendedSearch_1.ExtendedSearchDialog(controlColl, that.controlFactory.getCurrentInstance(), undefined, buttonControlDef);
            dlg.show((cancelled, changedInstance) => {
                if (!cancelled) {
                    that.controlFactory.changeInstance(changedInstance);
                    that.controlFactory.raiseOnChange(that.controlFactory, true);
                }
            });
        });
    }
}
class FTComboBoxState {
    constructor() {
        /**
        * True iff. the data for this FTComboBoxControl has not been fetched yet
        */
        this.dataFetched = false;
        /**
        * True iff. there is currently text filtering (autocomplete, search-in-ft) in effect
        */
        this.textFiltering = false;
        /**
        * True iff. there are more than one pages of T entries available for the given page size
        */
        this.moreThanOnePage = false;
    }
}
exports.FTComboBoxState = FTComboBoxState;
var AddEmptyEntry;
(function (AddEmptyEntry) {
    AddEmptyEntry[AddEmptyEntry["Default"] = 0] = "Default";
    AddEmptyEntry[AddEmptyEntry["Yes"] = 1] = "Yes";
    AddEmptyEntry[AddEmptyEntry["No"] = 2] = "No";
})(AddEmptyEntry = exports.AddEmptyEntry || (exports.AddEmptyEntry = {}));
class FTComboBoxControl extends FieldControl {
    constructor(prependId, typeId, mode, controlDef, controlFactory) {
        super(prependId, typeId, mode, controlDef, controlFactory);
        this.addEmptyEntry = AddEmptyEntry.Default;
        this.maxResults = 500;
        this.dataFetched = false;
        this.editBoxEnabled = controlDef.editBoxEnabled;
        this.addItemEnabled = controlDef.addItemEnabled;
        this.maxTextLength = controlDef.maxTextLength;
        this.tag = "select";
        this.cssClasses.push("ppInput");
        this.cssClasses.push("ppFTCombo");
    }
    highlightIfMandatoryAndEmpty() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let combo = $("#" + this.id).data("kendoComboBox");
            if (typeof combo === "undefined")
                return;
            let $input = combo.input;
            let target = $input.closest(".k-widget");
            target.removeClass("ppMandatory");
            if (this.mandatory) {
                let hasValue = this.getValue() != undefined;
                if (!hasValue) {
                    let inst = this.controlFactory.getCurrentInstance();
                    let hasPresentedValue = inst.items[this.field.presentedField].value != undefined;
                    if (!hasPresentedValue)
                        target.addClass("ppMandatory");
                }
            }
        });
    }
    getComboBoxState(that) {
        return $("#" + that.id).data("comboboxState");
    }
    resolveDataItem(that, dataItem, combo) {
        let d = $.Deferred();
        let instance = that.controlFactory.getCurrentInstance();
        if (that.forExternalInput) {
            instance.items[that.field.presentedField].clear();
            instance.items[that.field.fieldName].clear();
        }
        let requestData = {
            value: dataItem.realvalue,
            instance: instance.toJSON(),
            filtering: true,
            paging: true,
            pageSize: that.maxResults,
            page: 1
        };
        Utilities_1.synUtil.getAJAXData({
            method: "POST",
            url: Utilities_1.synUtil.getWSUrl("PropertypageForeigntableentries") + that.typeId + "/" + that.mode + "/" + encodeURIComponent(that.key) + "/new",
            requestData: JSON.stringify(requestData),
            done: (data) => {
                let tmp = Utilities_1.synUtil.fixForeignTable(data, that.mode);
                let colOnly = that.field.fieldName.substring(that.field.fieldName.indexOf(".") + 1);
                if (tmp.items.length > 0) {
                    let tmpItem = tmp.items[0];
                    dataItem.id = tmpItem.id;
                    dataItem.value = that.convert(tmpItem[colOnly], true);
                    combo.refresh();
                    combo.select(function (dataItem) {
                        return dataItem.id === tmpItem.id;
                    });
                }
                d.resolve(dataItem);
            }, fail: (jqXHR, textStatus, errorThrown, url) => {
                Utilities_1.synUtil.getAJAXDataFail(jqXHR, textStatus, errorThrown, url);
            }
        });
        return d.promise();
    }
    updateHeader(externalDataItem) {
        const that = this;
        let combo = $("#" + this.id).data("kendoComboBox");
        if (typeof combo === "undefined")
            return;
        let dataItem = externalDataItem || combo.dataItem();
        if (that.field.fieldConstraint & 32768 /* STYLE_SHOWICON */) {
            combo.input.addClass("ppIconCombo");
            combo.input.css("text-indent", that.height + "px");
            if (dataItem && dataItem.ceimage) {
                //re-fetch height
                combo.input.css("background-image", "url('" + Utilities_1.synUtil.getWSUrl("Icon")
                    + dataItem.ceimage + "/" + that.height + "')");
            }
            else {
                combo.input.removeClass("ppIconCombo");
                combo.input.css("background-image", "none");
            }
        }
        if (dataItem && dataItem.softDeleted && dataItem.showSoftDeletedWarning)
            combo.input.addClass("ppSoftDeletedEntryHeader");
        else
            combo.input.removeClass("ppSoftDeletedEntryHeader");
        if (dataItem && dataItem.hardDeleted)
            combo.input.addClass("ppHardDeletedEntryHeader");
        else
            combo.input.removeClass("ppHardDeletedEntryHeader");
        if (dataItem && dataItem.isAbstract)
            combo.input.addClass("ppAbstractEntryHeader");
        else
            combo.input.removeClass("ppAbstractEntryHeader");
    }
    /* Overwrite due to combobox needing tooltip on different element */
    applyToolTip(toolTipObj, jQueryElem) {
        const that = this;
        if (jQueryElem)
            jQueryElem.kendoTooltip(toolTipObj);
        else
            $("#" + that.id).closest(".k-widget")
                .children(".k-dropdown-wrap")
                .kendoTooltip(toolTipObj);
    }
    init(jqueryElem) {
        super.init(jqueryElem);
        const that = this;
        let idValueDuple;
        if (that.initialValue && that.initialValue instanceof FTControlValueDataType)
            idValueDuple = that.initialValue;
        else
            idValueDuple = new FTControlValueDataType();
        if (!(that.mode === Base_1.PropertyPageMode.Search && that.field.multiValue) && that.initialValue && idValueDuple.id && !that.forExternalInput) {
            let cvt = this.convert(idValueDuple.value, true);
            if (!cvt)
                cvt = "&nbsp;";
            jqueryElem.append($("<option value='" + idValueDuple.id + "'>" + cvt + "</option>"));
        }
        else
            jqueryElem.append($("<option value=''></option>"));
        let checkForExceeds = (combo) => {
            combo.list.children(".ppItemsExceeded").remove();
            combo.list.css("overflow", "hidden");
            if (!that.forExternalInput) {
                let listBox = combo.list.children(".k-list");
                listBox.css("height", "");
                let state = that.getComboBoxState(that);
                if (state.moreThanOnePage) {
                    let warnDiv = $("<div class='ppItemsExceeded'>" + kendo.format(Utilities_1.synUtil.convertFormatString(Utilities_1.synUtil.Strings.getValue("resultlimitedto", "Result limited to <{0}> entries. Please enter text to get all matches.")), that.maxResults) + "</div>").appendTo(combo.list);
                    combo.list.css("overflow", "visible");
                    let newHeight = 0;
                    if (combo.list.css("display") === "none") {
                        // Hack: We need to display the dropdownlist temporarily to calculate heights
                        let animationContainer = combo.list.closest(".k-animation-container");
                        // let oldLeft = animationContainer.css("left");
                        //animationContainer.css("left", "-10000px");
                        animationContainer.css("display", "block");
                        combo.list.css("display", "block");
                        newHeight = listBox.outerHeight() - (warnDiv.outerHeight());
                        combo.list.css("display", "none");
                        animationContainer.css("display", "none");
                        //animationContainer.css("left", oldLeft);
                    }
                    else
                        newHeight = listBox.outerHeight() - (warnDiv.outerHeight());
                    listBox.css("height", newHeight + "px");
                }
            }
        };
        let iconWsUrl = Utilities_1.synUtil.getWSUrl('Icon');
        let bHasDisplayFormat = false;
        let listWidthForDisplayFormat;
        let combo = jqueryElem.kendoComboBox({
            animation: false,
            dataTextField: "value",
            dataValueField: "id",
            enable: !that.readonly,
            filter: "contains",
            ignoreCase: false,
            // Warum clearButton=false? Begründung:
            // - Wird die Combobox mittels enable(false) disabled, ist der Clear-Button (aus meiner Sicht völlig unverständlich) rechts neben der Combobox immer noch existent
            // - Clickt man auf diesen Button, wird der Text der Combobox ausgeleert! Obwohl die Combobox disabled ist!
            // So aufgetreten im MVPickerAlternative1-Dialog:
            // - Ein Item hinzufügen
            // - Jetzt wird beim nun beim Item, das disabled ist, rechts daneben ein kleiner Button generiert. Klickt der Benuzter drauf, wird der Text der ComboBox ausgeleert!!
            // Behebung:
            // - Da wir derzeit den ClearButton ohnedies nicht verwenden, wird er hier auskommentiert.
            clearButton: false,
            template: "#  let classArray = []; \
                            let classes = classArray.join(' '); \
                            let useDisplayFormat = false; \
                            if(data.hasOwnProperty('displayFormat')) \
                                useDisplayFormat = true; \
                            let entryText = (data.hasOwnProperty('displayFormat') ? (data.displayFormat == undefined ? '' : data.displayFormat) : (data.value == undefined ? '' : data.value)); \
                            if(data.selected) \
                                classArray.push('ppFtCBSelectedEntry'); \
                            if(data.addEntry) \
                                entryText = data.addEntry; \
                            if(data.hardDeleted) \
                                entryText = kendo.format('" + that.hardDeletedFormatString + "', data.id); \
                            if(data.softDeleted && data.showSoftDeletedWarning) \
                                classArray.push('ppFtSoftDeletedEntry'); \
                            if(data.hardDeleted) \
                                classArray.push('ppFtHardDeletedEntry'); \
                            if(data.isAbstract) \
                                classArray.push('ppFtAbstractEntry'); \
                            if(data.addItem) \
                                classArray.push('ppAddItemEntry'); \
                            if(data.addedItem) \
                                classArray.push('ppAddedItemEntry'); \
                            classes = classArray.join(' ');  \
                            let ftIcon = ''; \
                            if(data.ceimage) \
                                ftIcon = '<img class=\\'ppFtIcon\\' alt=\\'\\' src=\\''+'" + iconWsUrl + "' + data.ceimage + '/' + data.ceimageHeight + '\\' />'; \
                            if(useDisplayFormat) {\
                                let outputString = ''; \
                                for (let i = 0; i < data.displayFormatColumnWidths.length; ++i) { \
                                    if(i === 0) \
                                        outputString += '<span class=\\'displayFormatFirst '+classes+'\\' style=\\'width:' + data.displayFormatColumnWidths[i] + '%;\\'>' + ftIcon + kendo.htmlEncode(data.displayFormat[i]).replace(' ', '&nbsp; ') + '</span>'; \
                                    else \
                                        outputString += '<span class=\\'displayFormat '+classes+'\\' style=\\'width:' + data.displayFormatColumnWidths[i] + '%;\\'>' + kendo.htmlEncode(data.displayFormat[i]).replace(' ', '&nbsp; ') + '</span>'; \
                                } \
                                return outputString; \
                            } else \
                                return '<span class=\\''+classes+'\\'>' + ftIcon + kendo.htmlEncode(entryText).replace(' ', '&nbsp; ') + ' </span>';#",
            //ftIcon = '<img alt= src=\\'" + synUtil.getWSUrl("IconInstance") + " + data.ceimage.toString() + '/16' + \\' /> '; \
            autoBind: false,
            minLength: 1,
            dataSource: new kendo.data.DataSource({
                serverFiltering: true,
                requestStart: (e) => {
                    //combo.enable(false);
                },
                requestEnd: (e) => {
                    //combo.enable(true);
                },
                transport: {
                    read: (options) => {
                        let state = that.getComboBoxState(that);
                        if (options.data.filter)
                            state.textFiltering = true;
                        else if (that.mode !== Base_1.PropertyPageMode.Search)
                            state.textFiltering = false;
                        let instance = that.controlFactory.getCurrentInstance();
                        // Der untere "auskommentierte" Source-Code ist KOMMENTAR!
                        // Das untere hier stört bei den externen Eingaben! Warum?
                        // Wenn ein FT-Entry, der nicht unter die ersten 500 fällt in der externen Eingabe in einer FTCombobox dargestellt werden muss,
                        // funktioniert das NUR, wenn dieser Eintrag in instance ENTHALTEN ist, denn nur dann stellt der Server sicher, dass dieser Eintrag
                        // in den zurückgelieferten FTEntries auch enthalten ist!
                        //if (that.forExternalInput) {
                        //    instance.items[that.field.presentedField].value = undefined;
                        //    instance.items[that.field.fieldName].value = undefined;
                        //}
                        let origPresentedValue = instance.items[that.field.presentedField].value;
                        if (origPresentedValue) {
                            if (Array.isArray(origPresentedValue)) {
                                // z.B. im Edit-Mode bei einem MV-Field in einer externen Eingabe (MVPickerAlternative1) kann man hier auch durchkommen. In diesem Fall ist origPresentedValue ein Array!
                                // --> den eigentlichen Value herausholen
                                if (origPresentedValue.length === 1)
                                    origPresentedValue = origPresentedValue[0];
                                else
                                    origPresentedValue = undefined;
                            }
                        }
                        let origOverrideStateId;
                        if (that.mode !== Base_1.PropertyPageMode.Search)
                            if (that.field.presentedField === "cgdocument.stateid") {
                                origOverrideStateId = instance.items["cgdocument.stateid"].value;
                                instance.items["cgdocument.stateid"] = instance.items["cgdocument.stateid"].clone();
                                instance.items["cgdocument.stateid"].value = that.controlFactory.instance.items["cgdocument.stateid"].value;
                            }
                        let requestData = {
                            instance: instance.toJSON(),
                            filtering: true,
                            filter: options.data.filter,
                            paging: true,
                            pageSize: that.maxResults,
                            page: 1,
                        };
                        if (that.addEmptyEntry !== AddEmptyEntry.Default) {
                            if (!options.data.filter) {
                                // WENN ein Filter angegeben ist, dann übernehmen wir den Default vom WEB-Service, ob ein empty entry vorhanden sein soll.
                                // (In diesem Fall liefert der Service dann KEINEN empty entry)
                                // Begründung:
                                // - Sobald ein Filter angegeben ist, würde ein empty entry stören bzw. ohnedies nicht zum Filter passen
                                // - Sobald ein Filter angegeben ist, öffnet sich die Combobox-Liste mit den zum Filter passenden Einträgen.
                                //   Ist dort aber auch ein leerer Eintrag enthalten, funktioniert die Bedienung der Combobox mit der Tastatur nicht mehr.
                                //   z.B. bewirkt die Taste "Down" nicht mehr, dass das nächste Element in der Liste selektiert wird.
                                if (that.addEmptyEntry === AddEmptyEntry.Yes)
                                    requestData.addEmptyEntry = true;
                                else if (that.addEmptyEntry === AddEmptyEntry.No)
                                    requestData.addEmptyEntry = false;
                            }
                        }
                        if (origOverrideStateId != undefined)
                            requestData.keepId = origOverrideStateId;
                        // Hinweis: keepId wird jetzt über die Instanz gemacht
                        // Sprich: jede externe Eingabe setzt den aktuell ausgewählten Eintrag in der instance der ControlFactory.
                        // Dieser Eintrag wird dann am Server als "keepId" gewertet.
                        Utilities_1.synUtil.getAJAXData({
                            method: "POST",
                            url: Utilities_1.synUtil.getWSUrl("PropertypageForeigntableentries") + that.typeId + "/" + that.mode + "/" + encodeURIComponent(that.key),
                            requestData: JSON.stringify(requestData),
                            done: (data) => {
                                that.dataFetched = true;
                                state.moreThanOnePage = data.pages > 1;
                                const tmp = Utilities_1.synUtil.fixForeignTable(data, that.mode);
                                const colOnly = that.field.fieldName.substring(that.field.fieldName.indexOf(".") + 1);
                                let displayFormatColCount;
                                const displayFormatColWidths = [];
                                if (that.field.fieldType === "String" && data.items.length >= 1 && data.items[0].hasOwnProperty("displayformat")) {
                                    let rowNumber = 0;
                                    bHasDisplayFormat = true;
                                    if (data.items[1] && data.items[1].hasOwnProperty("displayformat"))
                                        rowNumber = 1;
                                    if (data.items[rowNumber].displayformat != undefined)
                                        displayFormatColCount = data.items[rowNumber].displayformat.split("|").length;
                                    else
                                        displayFormatColCount = 1;
                                    // Calculate median text length for column distribution (% of width)
                                    const median = function (numbers) {
                                        const sorted = numbers.slice().sort();
                                        const middle = Math.floor(sorted.length / 2);
                                        if (sorted.length % 2 === 0)
                                            return (sorted[middle - 1] + sorted[middle]) / 2;
                                        return sorted[middle];
                                    };
                                    const displayFormatColLengths = [];
                                    let displayFormatColMedianLengths = [];
                                    for (let i = 0; i < displayFormatColCount; ++i)
                                        displayFormatColLengths.push([]);
                                    for (let i = 0; i < tmp.items.length; ++i) {
                                        const displayFormat = tmp.items[i].displayformat;
                                        if (!displayFormat)
                                            continue;
                                        const splitText = displayFormat.split("|");
                                        for (let j = 0; j < splitText.length && j < displayFormatColLengths.length; ++j)
                                            displayFormatColLengths[j].push(splitText[j].length);
                                    }
                                    for (let i = 0; i < displayFormatColCount; ++i)
                                        displayFormatColMedianLengths[i] = median(displayFormatColLengths[i].filter(item => item > 0));
                                    displayFormatColMedianLengths = displayFormatColMedianLengths.map(function (item) { return isNaN(item) ? 1 : item; });
                                    const displayFormatColSumLengths = displayFormatColMedianLengths.reduce((total, num) => { return total + num; });
                                    // Set dynamic list popup width based on median text length
                                    if (Utilities_1.synUtil.clientDeviceClass !== "phone" && displayFormatColSumLengths > 10) {
                                        const calcWidth = 0 + (displayFormatColSumLengths - 10) * 10;
                                        listWidthForDisplayFormat = calcWidth > ($(window).width()) - 10 ? ($(window).width()) - 10 : calcWidth;
                                    }
                                    const minColWidthPercent = 1;
                                    const colRestWidthPercent = 100 - minColWidthPercent * displayFormatColCount;
                                    for (let i = 0; i < displayFormatColCount; ++i)
                                        displayFormatColWidths[i] = minColWidthPercent + Math.floor(colRestWidthPercent * (displayFormatColMedianLengths[i] / displayFormatColSumLengths));
                                }
                                const conv = $.map(tmp.items, (elem, idx) => {
                                    let obj;
                                    if (!bHasDisplayFormat) {
                                        obj = {
                                            id: elem.id,
                                            sortIndex: elem.sortIndex,
                                            value: that.convert(elem[colOnly], true),
                                        };
                                    }
                                    else {
                                        obj = {
                                            id: elem.id,
                                            sortIndex: elem.sortIndex,
                                            value: that.convert(elem[colOnly], true),
                                            displayFormat: elem["displayformat"] ? (displayFormatColCount === 1 ? [elem["displayformat"]] : elem["displayformat"].split("|")) : Array(displayFormatColCount).fill(""),
                                            displayFormatColumnWidths: displayFormatColWidths
                                        };
                                    }
                                    if (elem.selected)
                                        obj.selected = true;
                                    if (elem._addItem)
                                        obj.addItem = true;
                                    if (elem._addedItem)
                                        obj.addedItem = true;
                                    if (elem._addEntry)
                                        obj.addEntry = elem._addEntry;
                                    if (elem.softDeleted)
                                        obj.softDeleted = true;
                                    if (elem.showSoftDeletedWarning)
                                        obj.showSoftDeletedWarning = true;
                                    if (elem.hardDeleted)
                                        obj.hardDeleted = true;
                                    if (elem._icon) {
                                        obj.ceimage = elem._icon;
                                        obj.ceimageHeight = that.height;
                                    }
                                    return obj;
                                });
                                if ((origPresentedValue) && (typeof origPresentedValue === "string")) {
                                    // origPresentedValue might be an extended search expression like 12||23, for which we don't want
                                    // the following check. The regex tests for extended search expression syntax.
                                    // Auch Variablen (z.B. #variable.currentuserid#) müssen an dieser Stelle erkannt werden
                                    // Werden Variablen an dieser Stelle nicht erkannt, dann führt das in folgender Situation zu Problemen:
                                    // - Erweiterte Suche öffnen
                                    // - Variable "Aktueller Benutzer" auswählen
                                    // - Erweiterte Suche mit OK schließen.
                                    // --> es erscheint die Fehlermeldung, dass ungespeicherte Änderungen nicht restauriert werden konnten.
                                    // Beim erneuten Öffnen der erweiterten Suche wird die Variable nicht angezeigt.
                                    let origPresentedValueAsString = origPresentedValue;
                                    if (!FTComboBoxControl.filterStringRegex.test(origPresentedValueAsString)) {
                                        if ($.grep(conv, c => c.id === origPresentedValueAsString).length === 0) {
                                            that.controlFactory.deleteWorkingValue(that.field.presentedField);
                                            that.controlFactory.propertyPagejQuery.trigger("ignoredValue", [that.field.presentedField]);
                                            that.controlFactory.notifyIgnoreField(that.field.presentedField);
                                        }
                                    }
                                }
                                conv.sort((a, b) => {
                                    let assignSortIndex = (elem) => {
                                        if (elem.addItem || elem.addedItem)
                                            return -3;
                                        else if (elem.selected)
                                            return -2;
                                        else
                                            return elem.sortIndex || -1;
                                    };
                                    let sortIndexA = assignSortIndex(a);
                                    let sortIndexB = assignSortIndex(b);
                                    return ((sortIndexA < sortIndexB) ? -1 : ((sortIndexA > sortIndexB) ? 1 : 0));
                                });
                                if (data.addEntry && options.data.filter) {
                                    let realvalue = options.data.filter.filters[0].value;
                                    if (typeof _.findWhere(conv, { value: realvalue }) === "undefined") {
                                        conv.push({
                                            id: "<ADDITEM>",
                                            sortIndex: conv.length,
                                            value: kendo.format(Utilities_1.synUtil.convertFormatString(Utilities_1.synUtil.Strings.getValue("dynpadditemformat", "Add <{0}> to table")), realvalue),
                                            realvalue
                                        });
                                    }
                                }
                                else if (conv.length === 0) {
                                    conv.push({
                                        id: "<NOITEM>",
                                        sortIndex: -4,
                                        value: Utilities_1.synUtil.Strings.getValue("dynpnomatchingitemfound")
                                    });
                                }
                                options.success(conv);
                                state.dataFetched = true;
                                if (state.textFiltering && conv.length)
                                    combo.open();
                                if (options.data && options.data.externalCallBack)
                                    options.data.externalCallBack(conv);
                                // Set dynamic width for combobox list
                                if (bHasDisplayFormat && listWidthForDisplayFormat != undefined)
                                    combo.list.css("width", listWidthForDisplayFormat);
                            }
                        });
                    }
                }
            }),
            dataBound: (e) => {
                checkForExceeds(e.sender);
                let dataItem = combo.dataItem(combo.select());
                that.updateHeader();
                if (dataItem) {
                    if (!dataItem.softDeleted || !dataItem.showSoftDeletedWarning) {
                        combo.input.removeClass("ppSoftDeletedEntryHeader");
                        combo.input.removeData("ppSoftDeleted");
                    }
                    if (!dataItem.hardDeleted) {
                        combo.input.removeClass("ppHardDeletedEntryHeader");
                        combo.input.removeData("ppHardDeleted");
                    }
                    if (!dataItem.isAbstract) {
                        combo.input.removeClass("ppAbstractEntryHeader");
                        combo.input.removeData("ppAbstract");
                    }
                }
                else {
                    combo.input.removeClass("ppSoftDeletedEntryHeader");
                    combo.input.removeClass("ppHardDeletedEntryHeader");
                    combo.input.removeClass("ppAbstractEntryHeader");
                    combo.input.removeData("ppSoftDeleted");
                    combo.input.removeData("ppHardDeleted");
                    combo.input.removeData("ppAbstract");
                }
                if (that.mode === Base_1.PropertyPageMode.Search) {
                    let dataItem = combo.dataItem(combo.select());
                    if (!dataItem) {
                        //For search, any text may be entered in a combobox.
                        // If text does not represent an actual selection, we have to set the
                        // presented value to undefined.
                    }
                }
                that.controlFactory.raiseonFtDataBound(e, that.controlFactory);
            },
            open: (e) => {
                // Pretty bad hack...
                if (combo.select() < 0 && !state.dataFetched && that.initialValue && combo.input.val() === idValueDuple.id)
                    combo.input.val("");
                if (bHasDisplayFormat && listWidthForDisplayFormat != undefined)
                    combo.list.width(listWidthForDisplayFormat);
                if (e.sender.list.outerWidth() < 200)
                    e.sender.list.css("width", "200px");
                checkForExceeds(e.sender);
            },
            close: (e) => {
                let combo = e.sender;
                if (combo._state !== "filter") {
                    // if ((<any>combo)._state === "accept")
                    let sel = combo.dataItem(combo.select());
                    let state = that.getComboBoxState(that);
                    if (!that.forExternalInput && that.mode !== Base_1.PropertyPageMode.Search) {
                        if (sel && !state.textFiltering) {
                            state.revertToData = sel;
                            let val = sel.value;
                            if (sel.hardDeleted)
                                val = kendo.format(that.hardDeletedFormatString, sel.id);
                            combo.input.val(val);
                        }
                        if (state.textFiltering) {
                            state.textFiltering = false;
                            combo.dataSource.filter({});
                        }
                    }
                    else {
                        if (sel || !sel && state.textFiltering) {
                            state.textFiltering = false;
                            combo.dataSource.filter({});
                        }
                    }
                }
            },
            select: (e) => {
                let combo = e.sender;
                if (e.item) {
                    let dataItem = combo.dataItem(e.item.index());
                    if (that.mode !== Base_1.PropertyPageMode.Search && dataItem.softDeleted)
                        e.preventDefault();
                    else if (!dataItem.softDeleted || !dataItem.showSoftDeletedWarning) {
                        combo.input.removeClass("ppSoftDeletedEntryHeader");
                        combo.input.removeData("ppSoftDeleted");
                    }
                    if (!dataItem.hardDeleted) {
                        combo.input.removeClass("ppHardDeletedEntryHeader");
                        combo.input.removeData("ppHardDeleted");
                    }
                }
            },
            change: (e) => {
                let combo = e.sender;
                let dataItem = combo.dataItem(combo.select());
                if (dataItem) {
                    let state = that.getComboBoxState(that);
                    if (dataItem.id === "<ADDITEM>") {
                        let dataItemResolved = that.resolveDataItem(that, dataItem, combo);
                        $.when(dataItemResolved).then(function (r) {
                            // ACHTUNG! HACK! Grundsätzliches Problem:
                            // - Model (that.controlFactory.setWorkingValue) wird hier ASYNCRON richtiggestellt!
                            // - Wenn aber DAVOR ein Zugriff auf das Model erfolgt, dann ist das Model noch nicht richtiggestellt!
                            // Derzeit ist kein Fall bekannt, wo das ein Problem ist. Es ist aber definitiv eine tickende Zeitbombe!
                            state.revertToData = r;
                            state.textFiltering = false;
                            let workingValue = r.id;
                            if ((that.mode !== Base_1.PropertyPageMode.Search && that.field.multiValue)) {
                                // Multivalue field --> value has to be an array!
                                workingValue = [r.id];
                            }
                            that.controlFactory.setWorkingValue(that.field.presentedField, workingValue);
                            that.notifyDependentControls();
                            that.notifyChange();
                            that.controlFactory.raiseOnFtFieldChange(that.controlFactory);
                            that.controlFactory.raiseOnChange(that.controlFactory, true);
                            that.updateHeader();
                        });
                    }
                    else if (dataItem.id === "<NOITEM>") {
                        combo.dataSource.remove(dataItem);
                        combo.value("");
                        combo.refresh();
                    }
                    else {
                        state.revertToData = dataItem;
                        state.textFiltering = false;
                        let workingValue = dataItem.id;
                        if ((that.mode !== Base_1.PropertyPageMode.Search && that.field.multiValue)) {
                            // Multivalue field --> value has to be an array!
                            workingValue = [dataItem.id];
                        }
                        that.controlFactory.setWorkingValue(that.field.presentedField, workingValue);
                        that.notifyDependentControls();
                        that.notifyChange();
                        that.controlFactory.raiseOnFtFieldChange(that.controlFactory);
                        that.controlFactory.raiseOnChange(that.controlFactory, true);
                        that.updateHeader();
                    }
                }
                else if (that.mode === Base_1.PropertyPageMode.Search) {
                    const presentedValue = that.controlFactory.getWorkingValue(that.field.presentedField, false);
                    if (presentedValue && !FTComboBoxControl.filterStringRegex.test(presentedValue)) {
                        that.controlFactory.deleteWorkingValue(that.field.presentedField);
                        that.notifyChange();
                    }
                }
                that.highlightIfMandatoryAndEmpty();
                that.controlFactory.raiseOnChange(that.controlFactory, true);
                that.updateHeader();
            }
        }).data("kendoComboBox");
        that.getDOMControl().attr("data-fieldname", that.field.fieldName);
        //Fetch listbox and make sure that items do not overflow break to the next line
        combo.list.addClass("ppFTEllipsis");
        // Apply tooltip
        if (that.toolTipObj)
            that.applyToolTipCore(that.toolTipObj, jqueryElem.data("kendoComboBox").wrapper.find(".k-input"));
        // Fix for IE8
        if (that.readonly)
            combo.input.removeAttr("disabled").attr("readonly", "readonly");
        if (that.initialValue)
            that.updateHeader(that.initialValue);
        // If autocomplete text has been entered, then deleted altogether,
        // this code resets the combobox's datasource accordingly.
        combo.input.on("keyup.debounced", Utilities_1.synUtil.throttleFunction((e) => {
            if (that.mode === Base_1.PropertyPageMode.Search) {
                if (!combo.input.val()) {
                    that.controlFactory.setWorkingValue(that.field.presentedField, undefined);
                    let myState = that.getComboBoxState(that);
                    myState.textFiltering = true;
                    combo.select((dataItem) => {
                        return dataItem.id === "";
                    });
                }
                else if (e.which === 13)
                    that.controlFactory.raiseOnSearch(that.controlFactory);
            }
            else if (!combo.input.val())
                combo.dataSource.filter({});
        }, 250));
        combo.input.on("keyup.immediately", () => {
            if (that.mode === Base_1.PropertyPageMode.Search)
                that.controlFactory.raiseOnDisposeExtendedSearchButton(that, true);
        });
        combo.input.on("focus", (e) => {
            let presentedField = that.controlFactory.getCurrentInstance().items[that.field.presentedField];
            if (presentedField.value || !that.getValue())
                that.controlFactory.raiseOnRequestExtendedSearchButton(that);
        });
        combo.input.on("blur", () => {
            that.controlFactory.raiseOnDisposeExtendedSearchButton(that);
        });
        if (!that.readonly) {
            // When entering text, the CSS classes for soft- or harddeleted entries must be temporarily removed
            combo.input.on("focus", () => {
                //$(this).select();
                if (combo.input.hasClass("ppSoftDeletedEntryHeader")) {
                    combo.input.removeClass("ppSoftDeletedEntryHeader");
                    combo.input.data("ppSoftDeleted", true);
                }
                else if (combo.input.hasClass("ppHardDeletedEntryHeader")) {
                    combo.input.removeClass("ppHardDeletedEntryHeader");
                    combo.input.data("ppHardDeleted", true);
                }
                if (combo.input.hasClass("ppAbstractEntryHeader")) {
                    combo.input.removeClass("ppAbstractEntryHeader");
                    combo.input.data("ppAbstract", true);
                }
            });
            combo.input.on("blur", () => {
                let state = that.getComboBoxState(that);
                if (that.mode !== Base_1.PropertyPageMode.Search)
                    state.textFiltering = false;
                if (combo.input.data("ppSoftDeleted")) {
                    combo.input.addClass("ppSoftDeletedEntryHeader");
                    combo.input.removeData("ppSoftDeleted");
                }
                else if (combo.input.data("ppHardDeleted")) {
                    combo.input.addClass("ppHardDeletedEntryHeader");
                    combo.input.removeData("ppHardDeleted");
                }
                if (combo.input.data("ppAbstract")) {
                    combo.input.addClass("ppAbstractEntryHeader");
                    combo.input.removeData("ppAbstract");
                }
                let dataItem = combo.dataItem(combo.select());
                if (dataItem == undefined) {
                    if (state.revertToData && that.mode !== Base_1.PropertyPageMode.Search) {
                        combo.select(state.revertToData);
                        combo.input.val(that.convert(state.revertToData.value, true));
                    }
                }
            });
        }
        let state = new FTComboBoxState();
        if (that.initialValue) {
            if (!(that.mode === Base_1.PropertyPageMode.Search && that.field.multiValue))
                state.revertToData = that.initialValue;
            if (that.initialFTEntries.softDeleted && that.initialFTEntries.showSoftDeletedWarning)
                combo.input.addClass("ppSoftDeletedEntryHeader");
            else if (that.initialFTEntries.hardDeleted)
                combo.input.addClass("ppHardDeletedEntryHeader");
            else if (that.initialFTEntries.isAbstract)
                combo.input.addClass("ppAbstractEntryHeader");
        }
        jqueryElem.data("comboboxState", state);
        combo.input.css({ position: "", top: "", left: "", padding: "0" });
    }
    destroy() {
        super.destroy();
        let jqueryElem = $("#" + this.id);
        if (jqueryElem.data("kendoComboBox"))
            jqueryElem.data("kendoComboBox").destroy();
        jqueryElem.removeData("comboboxState");
    }
    enable(enable) {
        super.enable(enable);
        let jqueryElem = $("#" + this.id);
        if (jqueryElem.data("kendoComboBox"))
            jqueryElem.data("kendoComboBox").enable(enable);
    }
    getDOMControl() {
        return $("#" + this.id).closest(".k-widget");
    }
    getInputControl() {
        return $("#" + this.id).data("kendoComboBox").input;
    }
    // Stellt den in value angegebenen FTEntry im FTComboBoxControl ein.
    // value enthält id UND value. id und value müssen immer "zusammenpassen".
    // value.id:
    //  =undefined: anschließend ist kein Wert im FTComboBoxControl eingestellt.
    //  =[]: anschließend ist kein Wert im FTComboBoxControl eingestellt.
    //  ="<id>": anschließend ist diese id im FTComboBoxControl eingestellt.
    //  =["<id>"]: anschließend ist diese id im FTComboBoxControl eingestellt.
    // value.value: siehe value.id
    // Wann muss bzw. darf value.id und value.value als Array übergeben werden? Wenn alle folgende Bedingungen zutreffen:
    // - MultiValue=true
    // - TreatAsSingleValue=false
    // - PageMode!==Search
    setValue(value) {
        const that = this;
        let jqueryElem = $("#" + that.id);
        that.destroy();
        let widget = jqueryElem.closest(".k-widget");
        let container = widget.parent();
        let valueInput = FTControlValueDataType.fromJSON({ id: undefined, value: undefined });
        if (value) {
            // Konvertierung von value nach FTControlValueDataType
            let valueObject = value;
            if (valueObject.hasOwnProperty("value")) {
                // Value liegt als id/value-Duple vor
                let idValueDuple = valueObject;
                if (Array.isArray(idValueDuple.value)) {
                    // Per Definition liegt der Wert eines MV-Feldes außer im Search-Mode in der instance IMMER als array vor!
                    // Wo wird eine FTComboBoxControl bei einem MV-Feld z.B. im Edit-Mode verwendet?
                    // Z.B.in einer externen Eingabe wie MVPickerAlternative1
                    let idValueDupleArray = valueObject;
                    switch (idValueDupleArray.value.length) {
                        case 0: {
                            valueInput.id = undefined;
                            valueInput.value = undefined;
                            break;
                        }
                        case 1: {
                            if ((idValueDupleArray.id) && (Array.isArray(idValueDupleArray.id)) && (idValueDupleArray.id.length === 1)) {
                                valueInput.id = idValueDupleArray.id[0];
                                valueInput.value = idValueDupleArray.value[0];
                            }
                            else {
                                // id ist nicht gesetzt
                                valueInput.id = undefined;
                                valueInput.value = idValueDupleArray.value[0];
                            }
                            break;
                        }
                        default: {
                            // Mehr wie ein Element kann die Combobox nicht darstellen --> ausleeren!
                            valueInput.id = undefined;
                            valueInput.value = undefined;
                            break;
                        }
                    }
                }
                else {
                    // Kein Array --> SingleValue-Fall
                    valueInput = FTControlValueDataType.fromJSON({ id: idValueDuple.id, value: idValueDuple.value });
                }
            }
            else {
                // Unzulässig! value kann bei FTComboboxControl nie vom Typ FieldValueDataType sein. FieldValueDataType muss in der Methodendeklaration nur angegeben sein, weil in der Basisklasse und in allen anderen Klassen so deklariert.
                throw TypeError("Wrong type of value"); // Nach bisherigen Erkenntnisstand dürfte dieser Fall nie auftreten und ist deshalb ein unzulässiger Aufruf dieser Methode.
            }
        }
        that.initialValue = valueInput;
        jqueryElem = that.tojQuery().insertBefore(widget);
        widget.remove();
        that.init(jqueryElem);
        that.setLayout(that.layout);
        let elem = $("#" + that.id);
        let state = elem.data("comboboxState");
        state.revertToData = valueInput;
        state.textFiltering = valueInput.value && !valueInput.id;
        let combo = elem.data("kendoComboBox");
        combo.input.val(that.convert(valueInput.value, true));
        let oldDataSource = combo.dataSource;
        combo.setDataSource(new kendo.data.DataSource());
        combo.setDataSource(oldDataSource);
        that.highlightIfMandatoryAndEmpty();
        // Kommentar zur folgenden Änderung:
        // 1. Warum die folgenden Zeilen so implementiert wurden, kann keiner mehr sagen. "oldId !== valueInput.id" ist völlig unverständlich
        // 2. Auch die Change-Historie im SVN dieser Stelle ist äußerst dubios
        // Folgendes soll durch an dieser Stelle erreicht werden:
        // - Wenn eine konkrete id in der FTComboBox selektiert werden soll, dann soll das hier (leider ansynchron) geschehen.
        // - Im Search-Mode muss noch überprüft werden, ob KEIN Filterstring vorliegt
        // Warum wurde diese Stelle umgebaut?
        // 1. Um einen Sourcecode zu haben, den man versteht!
        // 2. Wegen der Änderung in getIdString (siehe dort)
        // let oldId = that.getIdString();
        //if (this.mode !== PropertyPageMode.Search || (valueInput.id && (!FTComboBoxControl.filterStringRegex.test(valueInput.id) || oldId !== valueInput.id))) {
        if (this.mode !== Base_1.PropertyPageMode.Search || (valueInput.id && (!FTComboBoxControl.filterStringRegex.test(valueInput.id.toString())))) {
            oldDataSource.read({
                externalCallBack: (data) => {
                    combo.select((dataItem) => {
                        // DAS hier ist leider asynchron, OHNE durch ein Promise "abgesichert" zu sein!
                        return dataItem.id === valueInput.id;
                    });
                    that.updateHeader();
                    that.controlFactory.raiseControlRecreated(that);
                }
            });
        }
        else
            that.controlFactory.raiseControlRecreated(that);
    }
    // Hier wird NUR der value im Edit-Control des FTComboBoxControl gesetzt
    setValueString(value) {
        let combo = $("#" + this.id).data("kendoComboBox");
        combo.input.val(value);
    }
    // Liefert id des momentan eingestellen FTEntries immer als string, nie als Array.
    // Ist kein FTEntry ausgewählt, wird undefined zurückgegeben (hoffentlich - Grrr!)
    getIdString() {
        let elem = $("#" + this.id);
        let combo = elem.data("kendoComboBox");
        let sel = combo.dataItem(combo.select());
        // Kommentar zur folgenden Änderung:
        // Was soll diese Methode machen?
        // - Es soll IMMER die momentan eingestellte id zurückgeben
        // - Im SearchMode wird ev. auch einen FilterString zurückgegeben. z.B. 1||2
        // Warum wurde diese Stelle umgebaut?
        // 1. Weil diese Methode manchmal die id zurückgegen hat, manchmal den value. Das war für den Aufrufer nicht transparent!
        // 2. Um das Problem mit der Asynchronität von setValue zu entschärfen. Wenn noch KEINE id selektiert ist, wird einfach die id in state.revertToData.id
        //    zurückgegeben, die dann schon gesetzt ist.
        //    HINWEIS: das löst das Problem aber nur ZUM TEIL: Wenn nämlich die selektierte id mittels setValue GEÄNDERT wird und danach SOFORT getIdString aufgerufen wird,
        //    wird (vermutlich - ich hab das noch nicht getestet) ev. fälschlicherweise die ZUVOR eingestellte id zurückgegeben, wenn der asynchrone Teil in setValue noch nicht fertig ist.
        //    Das kann man nur Umbau auf Promise beheben.
        //if (sel) 
        //    return sel.id;
        //else {
        //    let state: FTComboBoxState = elem.data("comboboxState");
        //    if (that.mode === PropertyPageMode.Search) {
        //        if (combo.value() === "")
        //            return undefined;
        //        return combo.value();
        //    }
        //    else if (state.revertToData)
        //        return state.revertToData.id;
        //}
        // return undefined;
        if (sel)
            return sel.id;
        else {
            let state = elem.data("comboboxState");
            if (state.revertToData)
                return state.revertToData.id;
            else
                return undefined;
        }
    }
    // Liefert id des momentan eingestellen FTEntries so wie in setValue.
    // Das ist auch das Format, wie es in der instance erwartet wird.
    getId() {
        const that = this;
        let str = that.getIdString();
        if (str)
            return that.convertBack(str);
    }
    // Liefert den value des momentan eingestellen FTEntries immer als string, nie als Array.
    // Ist kein FTEntry ausgewählt, wird "" zurückgegeben (hoffentlich - Grrr!)
    getValueString() {
        const that = this;
        let elem = $("#" + this.id);
        let combo = elem.data("kendoComboBox");
        let sel = combo === null || combo === void 0 ? void 0 : combo.dataItem(combo.select());
        if (sel)
            // Case 1: An item from the combobox was actually selected
            return sel.value;
        else if (that.mode === Base_1.PropertyPageMode.Search && !that.forExternalInput) {
            // Case 2: No item was selected, but user entered text into the combobox's textarea.
            //         IF combobox is inside the extended search dialog, this is NOT allowed (rationale:
            //         inside the extended search dialog the user has to pick an entry).
            //         However, if the FT combobox appears in the property page, this string will be 
            //         used as value.
            return combo === null || combo === void 0 ? void 0 : combo.input.val().toString();
        }
        else {
            // Case 3: Combobox is in an intermediate state, so let's revert to the last selected
            //         item (if such an item exists) and return that.
            let state = elem.data("comboboxState");
            if (state.revertToData) {
                if (state.revertToData.value)
                    return state.revertToData.value;
            }
        }
        // Case 4: Nothing selected, nothing to revert to.
        return "";
    }
    // Liefert den value des momentan eingestellen FTEntries so wie in setValue.
    // Das ist auch das Format, wie es in der instance erwartet wird.
    getValue() {
        const that = this;
        return that.convertBack(that.getValueString());
    }
    setFocus() {
        $("#" + this.id).data("kendoComboBox").input.focus();
    }
    getIcon() {
        let elem = $("#" + this.id);
        let combo = elem.data("kendoComboBox");
        let sel = combo.dataItem(combo.select());
        if (sel)
            return sel.ceimage || undefined;
        else {
            let state = elem.data("comboboxState");
            if (state.revertToData)
                return state.revertToData.ceimage || undefined;
        }
        return undefined;
    }
    notifyChange() {
        const that = this;
        let combo = $("#" + that.id).data("kendoComboBox");
        let state = that.getComboBoxState(that);
        let val;
        if (that.controlFactory.hasWorkingValue(that.field.presentedField))
            val = that.controlFactory.getWorkingValue(that.field.presentedField, that.field.multiValue && !that.field.treatAsSingleValue);
        else if (that.initialValue)
            val = that.initialValue.id;
        let presentedValue = val ? val.toString() : "";
        let fetch = true;
        if (that.mode === Base_1.PropertyPageMode.Search) {
            if (state.textFiltering && (presentedValue === "" || FTComboBoxControl.filterStringRegex.test(presentedValue)))
                fetch = false;
        }
        else if (that.field.presentedField === "cgdocument.stateid" && that.dataFetched) {
            fetch = false;
            if (that.controlFactory.hasWorkingValue(that.field.presentedField)) {
                let curData = combo.dataSource.data();
                if (!curData || $.grep(curData, e => e.id === val).length === 0) {
                    that.controlFactory.deleteWorkingValue(that.field.presentedField);
                    that.controlFactory.propertyPagejQuery.trigger("ignoredValue", [that.field.presentedField]);
                    that.controlFactory.notifyIgnoreField(that.field.presentedField);
                }
            }
        }
        if (fetch) {
            combo.dataSource.fetch(() => {
                that.dataFetched = true;
                combo.input.removeClass("ppExtendedSearchHeader");
                // For search mode, don't necessarily select a combobox item, as the 
                // presentedValue might be a filter string consisting of several
                // ids / filterstring variables / expressions.
                if (that.mode === Base_1.PropertyPageMode.Search && FTComboBoxControl.filterStringRegex.test(presentedValue))
                    combo.input.addClass("ppExtendedSearchHeader").val("[...]");
                else
                    combo.select((dataItem) => { return dataItem.id === presentedValue; });
                that.updateHeader();
                state.textFiltering = false;
                that.highlightIfMandatoryAndEmpty();
                that.controlFactory.raiseOnFtFieldChange(that.controlFactory);
                that.controlFactory.raiseControlChange(that);
            });
        }
    }
    setLayoutFTComboBoxControl(layout) {
        if (layout === "absolute") {
            this.getDOMControl().find("input.k-input").css({
                height: this.height + "px"
            });
        }
    }
    setLayout(layout) {
        super.setLayout(layout);
        this.setLayoutFTComboBoxControl(layout);
    }
    setLayoutAnimated(layout) {
        super.setLayoutAnimated(layout);
        this.setLayoutFTComboBoxControl(layout);
    }
}
exports.FTComboBoxControl = FTComboBoxControl;
// This regex matches filterstrings
FTComboBoxControl.filterStringRegex = /(#variable\.[a-z]+#)|(\|\|)|(&&)|(<>)|(IS(NOT)?NULL)+/;
class ButtonGroupControl extends FieldControl {
    constructor(prependId, typeId, mode, controlDef, controlFactory) {
        super(prependId, typeId, mode, controlDef, controlFactory);
        this.initialized = false;
        this.overrideAttributes["data-fieldname"] = controlDef.field.fieldName;
        this.notSetInVisible = controlDef.notSetInVisible;
        this.multiValue = controlDef.type === "CheckBoxGroupCtrlInfo";
        this.cssClasses.push("ppButtonGroup");
        this.cssClasses.push("btn-group");
    }
    highlightIfMandatoryAndEmpty() {
        const that = this;
        $("#" + that.id).removeClass("ppMandatory");
        if (that.mode !== Base_1.PropertyPageMode.Search) {
            if (that.mandatory && that.isEmpty)
                $("#" + that.id).addClass("ppMandatory");
        }
    }
    _protectedFetchDataCore(callback) {
        const that = this;
        let domControl = that.getDOMControl().removeClass("initComplete");
        let requestData = {
            instance: that.controlFactory.getCurrentInstance().toJSON(),
        };
        let loadingDiv = $("<div class='k-loading-image'></div>").appendTo(domControl);
        Utilities_1.synUtil.getAJAXData({
            method: "POST",
            url: Utilities_1.synUtil.getWSUrl("PropertypageForeigntableentries") + that.typeId + "/" + that.mode + "/" + encodeURIComponent(that.key),
            requestData: JSON.stringify(requestData),
            done: (data) => {
                let tmp = Utilities_1.synUtil.fixForeignTable(data, that.mode);
                callback(tmp);
                domControl.addClass("initComplete");
            },
            cleanUp: () => { loadingDiv.remove(); }
        });
    }
    notifyChange() {
        const that = this;
        that._protectedFetchDataCore((data) => {
            let domControl = that.getDOMControl();
            domControl.html("");
            let selectedIds = that.controlFactory.getWorkingValue(that.field.fieldName, that.field.multiValue && !that.field.treatAsSingleValue);
            let noWorkingValue = !(that.controlFactory.getWorkingValue(that.field.fieldName, false));
            if (noWorkingValue)
                selectedIds = that.initialValue;
            if (typeof selectedIds === "string") {
                if (this.mode === Base_1.PropertyPageMode.Search)
                    selectedIds = Utilities_1.synUtil.splitWithoutEmptyEntries(selectedIds, "||");
                else if (that.field.multiValue)
                    selectedIds = Utilities_1.synUtil.splitWithoutEmptyEntries(selectedIds, ";");
            }
            let containsId = (id) => {
                if (that.field.multiValue || that.mode === Base_1.PropertyPageMode.Search)
                    return ($.inArray(id, selectedIds) >= 0);
                return selectedIds === id;
            };
            let ignoredValue = false;
            if (that.field.multiValue && !that.field.treatAsSingleValue || that.mode === Base_1.PropertyPageMode.Search) {
                let corrSelectedIds = [];
                if (selectedIds.length !== 0) {
                    for (let i = 0; i < selectedIds.length; ++i)
                        if ($.grep(data.items, d => d.id === selectedIds[i]).length !== 0)
                            corrSelectedIds.push(selectedIds[i]);
                    if (corrSelectedIds.length !== selectedIds.length) {
                        if (noWorkingValue)
                            that.initialValue = corrSelectedIds;
                        else
                            that.controlFactory.setWorkingValue(that.field.fieldName, corrSelectedIds);
                        ignoredValue = true;
                    }
                }
            }
            else {
                if (selectedIds) {
                    if ($.grep(data.items, d => d.id === selectedIds).length === 0) {
                        if (noWorkingValue)
                            that.initialValue = undefined;
                        else
                            that.controlFactory.deleteWorkingValue(that.field.fieldName);
                        ignoredValue = true;
                    }
                }
            }
            if (ignoredValue) {
                that.controlFactory.propertyPagejQuery.trigger("ignoredValue", [that.field.fieldName]);
                that.controlFactory.notifyIgnoreField(that.field.fieldName);
            }
            let pref = that.id.substring(1) + "_";
            let createButtonGroupItemNew = (item) => {
                let buttonID = "cb_" + pref + item.id;
                let itemDiv = $("<button type='button' id='" + buttonID + "' class='ppButtonGroupButton btn'>" + kendo.htmlEncode(item.buttongroup)
                    + "</button>").appendTo(domControl);
                if (item.isUnsetButton)
                    itemDiv.addClass("ppUnsetButton");
                itemDiv.attr("data-id", item.id);
                if (that.mode === Base_1.PropertyPageMode.View)
                    itemDiv.addClass("disabled");
                if (item.hardDeleted)
                    itemDiv.addClass("ppHardDeletedButton");
                else if (item.softDeleted)
                    itemDiv.addClass("ppSoftDeletedButton");
                return itemDiv;
            };
            let maxWidth = 0;
            $.each(data.items, (idx, item) => {
                let measureDiv = createButtonGroupItemNew(item);
                // getHiddenDimensions liefert auch die Abmessungen für unsichtbare Controls. Laut Tests liefert es auch bei sichtbaren Controls die gleichen Werte wie die alte Methode: Math.max(measureDiv.innerWidth(), maxWidthOld);
                let dim = this.getHiddenDimensions(measureDiv, false);
                maxWidth = Math.max(dim.innerWidth, maxWidth);
                measureDiv.remove();
            });
            $.each(data.items, (idx, item) => {
                let divWrapper = createButtonGroupItemNew(item)
                    .innerWidth(maxWidth)
                    .on("click", (e) => {
                    if (!that.readonly) {
                        let button = $(e.target);
                        let isActive = button.hasClass("active");
                        if (that.multiValue) {
                            if (isActive)
                                button.removeClass("active").addClass("inactive");
                            else
                                button.removeClass("inactive").addClass("active");
                        }
                        else {
                            let buttonId = button.attr("data-id");
                            if (!isActive) {
                                $.each(domControl.children(".ppButtonGroupButton"), function (idx, elem) {
                                    if ($(elem).attr("data-id") !== buttonId)
                                        $(elem).removeClass("active").addClass("inactive");
                                    else
                                        $(elem).removeClass("inactive").addClass("active");
                                });
                            }
                        }
                        that.controlFactory.setWorkingValue(that.field.fieldName, that.getValue() || undefined);
                        if (that.mode !== Base_1.PropertyPageMode.Search)
                            that.notifyDependentControls();
                        if (that.mode !== Base_1.PropertyPageMode.Search) {
                            let hasVal = !that.isEmpty;
                            if (that.mandatory && !hasVal)
                                $("#" + that.id).addClass("ppMandatory");
                            else
                                $("#" + that.id).removeClass("ppMandatory");
                        }
                        that.highlightIfMandatoryAndEmpty();
                        that.controlFactory.raiseOnChange(that.controlFactory, true);
                        that.controlFactory.raiseOnFtFieldChange(that.controlFactory);
                    }
                    e.preventDefault();
                    return false;
                });
                if (item.id && containsId(item.id))
                    divWrapper.addClass("active");
                else
                    divWrapper.addClass("inactive");
            });
            that.controlFactory.raiseControlChange(that);
            let initialNotifyChangeNecessary = !that.initialized;
            that.initialized = true;
            if (initialNotifyChangeNecessary)
                that.controlFactory.raiseOnChange(that.controlFactory, false);
            that.highlightIfMandatoryAndEmpty();
        });
    }
    getValue() {
        if (!this.initialized) {
            if (this.mode === Base_1.PropertyPageMode.Search)
                return "";
            return (this.field.multiValue ? [] : undefined);
        }
        let domControl = this.getDOMControl();
        let ids = [];
        domControl.find(".ppButtonGroupButton.active").not(".ppUnsetButton")
            .each((idx, item) => {
            ids.push($(item).attr("data-id"));
        });
        if (this.multiValue) {
            if (this.mode === Base_1.PropertyPageMode.Search)
                return ids.join("||");
            return ids;
        }
        else {
            if (ids.length)
                return ids[0];
            if (this.mode === Base_1.PropertyPageMode.Search)
                return "";
            return undefined;
        }
    }
    setValue(value) {
        this.initialValue = value;
        this.highlightIfMandatoryAndEmpty();
        this.notifyChange();
    }
    lateInit(jqueryElem) {
        this.notifyChange();
    }
    enable(enable) {
        super.enable(enable);
        Utilities_1.synUtil.toggleEnabledState($("#" + this.id).find(".ppButtonGroupButton"), enable);
    }
    setLayoutButtonGroupControl(layout) {
        if (layout !== "absolute")
            this.getDOMControl().css("height", "");
    }
    setLayout(layout) {
        super.setLayout(layout);
        this.setLayoutButtonGroupControl(layout);
    }
    setLayoutAnimated(layout) {
        super.setLayoutAnimated(layout);
        this.setLayoutButtonGroupControl(layout);
    }
    // Check if button for a given id is currently displayed.
    hasButtonForId(id) {
        let domControl = this.getDOMControl();
        let found = domControl.find(".ppButtonGroupButton[data-id='" + id + "']");
        return found.length === 1;
    }
    setFocus() {
    }
}
class AbstractFormatStringControl extends FieldControl {
}
class NumericTextBoxControl extends AbstractFormatStringControl {
    constructor(prependId, typeId, mode, controlDef, controlFactory) {
        super(prependId, typeId, mode, controlDef, controlFactory);
        this.tag = "input";
        this.cssClasses.push("ppInput");
        this.cssClasses.push("ppNumericTextBox");
    }
    init(jqueryElem) {
        super.init(jqueryElem);
        const that = this;
        let fmt = that.formatString || "#";
        let decimals;
        let spl = Utilities_1.synUtil.splitWithoutEmptyEntries(fmt, ".");
        if (spl.length > 1)
            decimals = spl[1].length;
        if (that.field.fieldType === "Digit" || that.field.fieldType === "BigDigit")
            decimals = 0;
        let max = 2147483647;
        let min = -2147483648;
        if (that.field.fieldType === "Float") {
            max = 3.40282e+038;
            min = -3.40282e+038;
        }
        else if (that.field.fieldType === "BigDigit") {
            max = Number.MAX_SAFE_INTEGER;
            min = -Number.MAX_SAFE_INTEGER;
        }
        let settings = {
            spinners: false,
            format: fmt,
            decimals,
            max,
            min,
            restrictDecimals: true,
            change: (e) => {
                that.highlightIfMandatoryAndEmpty();
                that.controlFactory.raiseOnChange(that.controlFactory, true);
            }
        };
        if (!that.formatString && that.field.fieldType === "Float")
            settings.decimals = 8;
        jqueryElem.kendoNumericTextBox(settings);
        that.getDOMControl().attr("data-fieldname", that.field.fieldName);
        jqueryElem.parent().children("input.k-input").css({ position: "", top: "", left: "", padding: "0" }).removeAttr("title");
        if (this.mode === Base_1.PropertyPageMode.Search)
            jqueryElem.parent().children("input.k-input")
                .on("keyup", (e) => {
                if (e.which === 13) {
                    that.controlFactory.raiseOnSearch(that.controlFactory);
                }
            });
        if (that.readonly)
            jqueryElem.data("kendoNumericTextBox").readonly(true);
        if (that.initialValue != undefined && !that.forExternalInput)
            that.setValue(that.initialValue);
    }
    highlightIfMandatoryAndEmpty() {
        let target = $("#" + this.id).closest(".k-widget").find(".ppInput");
        target.removeClass("ppMandatory");
        if (this.mandatory) {
            if (this.field.isFTRepresentativeField && this.getValue() == undefined) {
                if (!this.controlFactory.getCurrentInstance().items[this.field.presentedField].value)
                    target.addClass("ppMandatory");
            }
            else if (this.getValue() == undefined)
                target.addClass("ppMandatory");
        }
    }
    destroy() {
        super.destroy();
        let jqueryElem = $("#" + this.id);
        if (jqueryElem.data("kendoNumericTextBox"))
            jqueryElem.data("kendoNumericTextBox").destroy();
    }
    applyToolTip(toolTipObj) {
        super.applyToolTip(toolTipObj, $("#" + this.id));
        $("#" + this.id).closest(".k-numeric-wrap")
            .children(".k-formatted-value")
            .kendoTooltip(toolTipObj);
    }
    setValue(value) {
        if (typeof value == "number")
            $("#" + this.id).data("kendoNumericTextBox").value(value);
        else if (typeof value == "string")
            $("#" + this.id).data("kendoNumericTextBox").value(value);
        else if (value == undefined)
            // eslint-disable-next-line no-null/no-null
            $("#" + this.id).data("kendoNumericTextBox").value(null); // kendo verlangt null
        else
            throw new TypeError("value is of invalid datatype.");
        this.highlightIfMandatoryAndEmpty();
        // Remove tooltip
        $("#" + this.id).parent().children("input.k-input").removeAttr("title");
    }
    getValue() {
        return $("#" + this.id).data("kendoNumericTextBox").value();
    }
    setFocus() {
        let jqueryElem = $("#" + this.id);
        if (jqueryElem.data("kendoNumericTextBox"))
            jqueryElem.data("kendoNumericTextBox").focus();
    }
    tojQuery() {
        const that = this;
        let jq = $("<" + that.tag + "></" + that.tag + ">")
            .css(that.getCSS())
            .attr(that.getAttributes())
            .addClass(that.cssClasses.join(" "))
            .data("control", that);
        // handle copy+paste
        jq.on("blur", () => {
            jq.prev(".k-formatted-value").removeAttr("title");
        });
        jq.on("input change", Utilities_1.synUtil.throttleFunction(() => {
            let val = jq.val();
            // If current text content of textbox is non-empty AND ends with 0 or a non-numeric
            // character, we assume that the user is currently typing the value and don't update
            // the control's internal representation of that value; otherwise, trailing zeroes or
            // commas might be removed, which would render typing in values such as "0.0015" 
            // impossible
            if (val && val.length > 0) {
                if (that.field.fieldType === "Float") {
                    let decimalSeparator = kendo.culture().numberFormat["."];
                    let decIdx = val.indexOf(decimalSeparator);
                    if (decIdx >= 0) {
                        if (decIdx === 0)
                            return;
                        else if (!$.isNumeric(val[val.length - 1]) || val[val.length - 1] === '0')
                            return;
                    }
                }
                if (val.length === 1 && val[0] === "-")
                    return;
            }
            that.setValue(val);
            jq.prev(".k-formatted-value").removeAttr("title");
            that.controlFactory.raiseOnChange(that.controlFactory, true);
            that.highlightIfMandatoryAndEmpty();
        }, 250));
        return jq;
    }
    enable(enable) {
        super.enable(enable);
        $("#" + this.id).data("kendoNumericTextBox").enable(enable);
    }
    getDOMControl() {
        return $("#" + this.id).closest(".k-widget");
    }
    getInputControl() {
        return this.getDOMControl().find("input.k-formatted-value");
    }
}
exports.NumericTextBoxControl = NumericTextBoxControl;
class DateControl extends AbstractFormatStringControl {
    constructor(prependId, typeId, mode, controlDef, controlFactory) {
        super(prependId, typeId, mode, controlDef, controlFactory);
        this.tag = "input";
        this.cssClasses.push("ppInput");
        this.cssClasses.push("datetimeNoValue");
        this.overrideAttributes.spellcheck = "false";
        switch (this.type) {
            case "DateCtrlInfo":
                this.cssClasses.push("ppDate");
                if (!this.formatString)
                    this.formatString = "d";
                break;
            case "TimeCtrlInfo":
                this.cssClasses.push("ppTime");
                if (!this.formatString)
                    this.formatString = "T";
                break;
            case "DateAndTimeCtrlInfo":
            default:
                this.cssClasses.push("ppDateTime");
                if (!this.formatString)
                    this.formatString = "G";
                break;
        }
    }
    tojQuery() {
        const that = this;
        let jq = $("<" + this.tag + "></" + this.tag + ">")
            .css(this.getCSS())
            .attr(this.getAttributes())
            .addClass(this.cssClasses.join(" "))
            .data("control", this);
        // handle focus
        jq.on("focus", () => {
            that.updateCSSClass();
            let jqueryElement = that.getjqueryElement();
            if (kendo.support.browser.edge)
                // See https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/8229660/
                // https://stackoverflow.com/questions/38487059/selecting-all-content-of-text-input-on-focus-doesnt-work-in-microsoft-edge
                setTimeout(function () { jqueryElement.select(); }, 10);
            else
                jqueryElement.select();
        });
        // handle blur
        jq.on("blur", () => {
            that.updateCSSClass();
        });
        return jq;
    }
    updateCSSClass() {
        let bFocused = false;
        let jqueryElement = this.getjqueryElement();
        if (jqueryElement)
            bFocused = (jqueryElement.is(':focus'));
        if ((!this.getValue()) && (!bFocused))
            $("#" + this.id).addClass("datetimeNoValue");
        else
            $("#" + this.id).removeClass("datetimeNoValue");
    }
    getjqueryElement() {
        let jqueryElementReturn;
        let jqueryElem = $("#" + this.id);
        switch (this.type) {
            case "DateCtrlInfo":
                let datePicker = jqueryElem.data("kendoDatePicker");
                if (datePicker)
                    jqueryElementReturn = datePicker.element;
                break;
            case "TimeCtrlInfo":
                let timePicker = jqueryElem.data("kendoTimePicker");
                if (timePicker)
                    jqueryElementReturn = timePicker.element;
                break;
            case "DateAndTimeCtrlInfo":
            default:
                let datetimePicker = jqueryElem.data("kendoDateTimePicker");
                if (datetimePicker)
                    jqueryElementReturn = datetimePicker.element;
                break;
        }
        return jqueryElementReturn;
    }
    getValue() {
        let jqueryElem = $("#" + this.id);
        let dateVal;
        switch (this.type) {
            case "DateCtrlInfo":
                let datePicker = jqueryElem.data("kendoDatePicker");
                if (datePicker)
                    dateVal = datePicker.value();
                break;
            case "TimeCtrlInfo":
                let timePicker = jqueryElem.data("kendoTimePicker");
                if (timePicker)
                    dateVal = timePicker.value();
                break;
            case "DateAndTimeCtrlInfo":
            default:
                let datetimePicker = jqueryElem.data("kendoDateTimePicker");
                if (datetimePicker)
                    dateVal = datetimePicker.value();
                break;
        }
        if (dateVal)
            return dateVal;
        return undefined;
    }
    getDOMControl() {
        return $("#" + this.id).closest(".k-widget");
    }
    getInputControl() {
        return $("#" + this.id);
    }
    setValue(value) {
        let jqueryElem = $("#" + this.id);
        if (value instanceof Date) {
            let valueDate = value;
            switch (this.type) {
                case "DateCtrlInfo":
                    jqueryElem.data("kendoDatePicker").value(valueDate);
                    break;
                case "TimeCtrlInfo":
                    jqueryElem.data("kendoTimePicker").value(valueDate);
                    break;
                case "DateAndTimeCtrlInfo":
                default:
                    jqueryElem.data("kendoDateTimePicker").value(valueDate);
                    break;
            }
        }
        else if (typeof value == "string") {
            let valueDate = value;
            switch (this.type) {
                case "DateCtrlInfo":
                    jqueryElem.data("kendoDatePicker").value(valueDate);
                    break;
                case "TimeCtrlInfo":
                    jqueryElem.data("kendoTimePicker").value(valueDate);
                    break;
                case "DateAndTimeCtrlInfo":
                default:
                    jqueryElem.data("kendoDateTimePicker").value(valueDate);
                    break;
            }
        }
        else if (value == undefined) {
            // eslint-disable-next-line no-null/no-null
            const valueDate = null; // kendo verlangt null!
            switch (this.type) {
                case "DateCtrlInfo":
                    jqueryElem.data("kendoDatePicker").value(valueDate);
                    break;
                case "TimeCtrlInfo":
                    jqueryElem.data("kendoTimePicker").value(valueDate);
                    break;
                case "DateAndTimeCtrlInfo":
                default:
                    jqueryElem.data("kendoDateTimePicker").value(valueDate);
                    break;
            }
        }
        else
            throw new TypeError("value is of invalid datatype.");
        this.highlightIfMandatoryAndEmpty();
        this.updateCSSClass();
    }
    setFocus() {
        let jqueryElem = $("#" + this.id);
        switch (this.type) {
            case "DateCtrlInfo":
                jqueryElem.data("kendoDatePicker").element.focus();
                break;
            case "TimeCtrlInfo":
                jqueryElem.data("kendoTimePicker").element.focus();
                break;
            case "DateAndTimeCtrlInfo":
            default:
                jqueryElem.data("kendoDateTimePicker").element.focus();
                break;
        }
    }
    init(jqueryElem) {
        super.init(jqueryElem);
        const that = this;
        let parseFormats;
        let configOptions = {
            format: that.formatString,
            change: () => {
                that.highlightIfMandatoryAndEmpty();
                that.controlFactory.raiseOnChange(that.controlFactory, true);
            }
        };
        switch (that.type) {
            case "DateCtrlInfo":
                configOptions.min = new Date(1601, 0, 1);
                configOptions.max = new Date(9999, 12, 31);
                if (!that.readonly)
                    configOptions.dateInput = true;
                jqueryElem.kendoDatePicker(configOptions);
                jqueryElem.data("kendoDatePicker").enable(!that.readonly);
                break;
            case "TimeCtrlInfo":
                parseFormats = {
                    parseFormats: ["T", "t"] // Gültig sind auch: Stunden+Minuten+Sekunden, Stunden+Minuten
                };
                _.extend(configOptions, parseFormats);
                if (!that.readonly)
                    configOptions.dateInput = true;
                jqueryElem.kendoTimePicker(configOptions);
                jqueryElem.data("kendoTimePicker").enable(!that.readonly);
                break;
            case "DateAndTimeCtrlInfo":
            default:
                configOptions.min = new Date(1601, 0, 1, 0, 0, 0);
                configOptions.max = new Date(9999, 12, 31, 23, 59, 59);
                parseFormats = {
                    parseFormats: ["G", "g", "d"] // Gültig sind auch: Datum+Stunden+Minuten+Sekunden, Datum+Stunden+Minuten, Datum
                };
                _.extend(configOptions, parseFormats);
                if (!that.readonly)
                    configOptions.dateInput = true;
                jqueryElem.kendoDateTimePicker(configOptions);
                let control = jqueryElem.data("kendoDateTimePicker");
                control.enable(!that.readonly);
                break;
        }
        that.getDOMControl().attr("data-fieldname", that.field.fieldName);
        if (that.readonly)
            jqueryElem.removeAttr("disabled").attr("readonly", "readonly");
        if (that.initialValue && !that.forExternalInput)
            that.setValue(that.initialValue);
        if (that.readonly)
            jqueryElem.attr("readonly", "readonly");
        jqueryElem.css({ position: "", top: "", left: "", padding: "0" });
    }
    destroy() {
        super.destroy();
        let jQueryElem = $("#" + this.id);
        switch (this.type) {
            case "DateCtrlInfo":
                if (jQueryElem.data("kendoDatePicker"))
                    jQueryElem.data("kendoDatePicker").destroy();
                break;
            case "TimeCtrlInfo":
                if (jQueryElem.data("kendoTimePicker"))
                    jQueryElem.data("kendoTimePicker").destroy();
                break;
            case "DateAndTimeCtrlInfo":
            default:
                if (jQueryElem.data("kendoDateTimePicker"))
                    jQueryElem.data("kendoDateTimePicker").destroy();
                break;
        }
    }
    enable(enable) {
        super.enable(enable);
        let jqueryElem = $("#" + this.id);
        switch (this.type) {
            case "DateCtrlInfo":
                jqueryElem.data("kendoDatePicker").enable(enable);
                break;
            case "TimeCtrlInfo":
                jqueryElem.data("kendoTimePicker").enable(enable);
                break;
            case "DateAndTimeCtrlInfo":
            default:
                jqueryElem.data("kendoDateTimePicker").enable(enable);
                break;
        }
    }
    setLayoutDateControl(layout) {
        if (layout === "absolute") {
            this.getDOMControl().find("input.k-input").css({
                height: this.height + "px"
            });
        }
    }
    setLayout(layout) {
        super.setLayout(layout);
        this.setLayoutDateControl(layout);
    }
    setLayoutAnimated(layout) {
        super.setLayoutAnimated(layout);
        this.setLayoutDateControl(layout);
    }
}
class ImageControl extends FieldControl {
    constructor(prependId, typeId, mode, controlDef, controlFactory) {
        super(prependId, typeId, mode, controlDef, controlFactory);
        this.overrideAttributes["data-fieldname"] = controlDef.field.fieldName;
        this.imageFileName = controlDef.imageFileName;
        this.desiredSize = controlDef.desiredSize;
    }
    setFocus() {
    }
    getValue() {
        throw new Error("Method not implemented.");
    }
    setValue(value) {
        const isImageFileName = value && value.toString().startsWith("docid=");
        let oldVal = isImageFileName ? this.imageFileName : this.imageId;
        this.imageFileName = "";
        this.imageId = "";
        if (isImageFileName)
            this.imageFileName = value ? value.toString() : "";
        else
            this.imageId = value ? value.toString() : "";
        const cmpValue = isImageFileName ? this.imageFileName : this.imageId;
        if (oldVal !== cmpValue) {
            this.notifyChange();
            this.highlightIfMandatoryAndEmpty();
        }
    }
    notifyChange() {
        const that = this;
        if (that.imageFileName) {
            $("#" + that.id).css({
                "background-image": "url('" + Utilities_1.synUtil.getWSUrl("Icon")
                    + that.imageFileName
                    + "/" + parseInt(that.desiredSize, 10).toString() + "')"
            });
        }
        else if (that.imageId) {
            $("#" + that.id).css({
                "background-image": "url('" + Utilities_1.synUtil.getWSUrl("Icon")
                    + "docid=" + that.imageId
                    + "/" + parseInt(that.desiredSize, 10).toString() + "')"
            });
        }
        else
            $("#" + that.id).css("background-image", "");
        that.highlightIfMandatoryAndEmpty();
        that.controlFactory.raiseControlChange(that);
    }
    init(jqueryElem) {
        super.init(jqueryElem);
        jqueryElem.css("background-position", "50% 50%");
        jqueryElem.css("background-repeat", "no-repeat");
        this.notifyChange();
    }
}
class CheckBoxControl extends FieldControl {
    constructor(prependId, typeId, mode, controlDef, controlFactory) {
        super(prependId, typeId, mode, controlDef, controlFactory);
        this.overrideAttributes["data-fieldname"] = controlDef.field.fieldName;
        this.tag = "div";
        this.checkBoxId = this.id + "_checkbox";
        this.cssClasses.push("ppInput");
        this.cssClasses.push("ppCheckBox");
    }
    init(jQueryElem) {
        const that = this;
        super.init(jQueryElem);
        let checkBox = $("<input>")
            .attr({
            "id": that.checkBoxId,
            "type": "checkbox"
        })
            .addClass("ppCheckBoxCbControl")
            .appendTo(jQueryElem);
        if (that.initialValue === true)
            checkBox.attr("data-hasvalue", "true").attr("checked", "checked");
        else if (that.initialValue === false)
            checkBox.attr("data-hasvalue", "true");
        else
            checkBox.attr("data-hasvalue", "false");
        if (that.readonly)
            checkBox.attr("disabled", "disabled");
        jQueryElem.on("change", () => {
            checkBox.attr("data-hasvalue", "true");
            that.highlightIfMandatoryAndEmpty();
            that.controlFactory.raiseOnChange(that.controlFactory, true);
            that.controlFactory.raiseOnBoolFieldChange(that.controlFactory);
        });
    }
    getInputControl() {
        return $("#" + this.checkBoxId);
    }
    getValue() {
        let elem = $("#" + this.checkBoxId);
        if (elem.attr("data-hasvalue") === "true")
            return elem.prop("checked");
        return undefined;
    }
    setValue(value) {
        let checkbox = $("#" + this.checkBoxId);
        if (value === true)
            checkbox.attr("data-hasvalue", "true").attr("checked", "checked");
        else if (value === false)
            checkbox.attr("data-hasvalue", "true").removeAttr("checked");
        else
            checkbox.removeAttr("data-hasvalue").removeAttr("checked");
        this.highlightIfMandatoryAndEmpty();
    }
    setFocus() {
    }
    setLayoutCheckBoxControl(layout) {
        if (layout !== "absolute") {
            this.getDOMControl().css({
                "width": "",
                "line-height": ""
            });
        }
        else
            this.getDOMControl().css("line-height", this.getDOMControl().css("height"));
    }
    setLayout(layout) {
        super.setLayout(layout);
        this.setLayoutCheckBoxControl(layout);
    }
    setLayoutAnimated(layout) {
        super.setLayoutAnimated(layout);
        this.setLayoutCheckBoxControl(layout);
    }
    enable(enable) {
        super.enable(enable);
        if (enable)
            $("#" + this.checkBoxId).removeAttr("disabled");
        else
            $("#" + this.checkBoxId).attr("disabled", "disabled");
    }
}
class BoolComboBoxControl extends FieldControl {
    constructor(prependId, typeId, mode, controlDef, controlFactory) {
        super(prependId, typeId, mode, controlDef, controlFactory);
        this.overrideAttributes["data-fieldname"] = controlDef.field.fieldName;
        this.tag = "select";
        this.cssClasses.push("ppBoolComboBox");
    }
    init(jqueryElem) {
        super.init(jqueryElem);
        const that = this;
        $("<option value='' />").text(Utilities_1.synUtil.Strings.getValue("dynpboolempty")).appendTo(jqueryElem);
        $("<option value='Y' />").text(Utilities_1.synUtil.Strings.getValue("dynpbooltrue")).appendTo(jqueryElem);
        $("<option value='N' />").text(Utilities_1.synUtil.Strings.getValue("dynpboolfalse")).appendTo(jqueryElem);
        that.combo = jqueryElem.kendoDropDownList({
            change: () => {
                that.highlightIfMandatoryAndEmpty();
                that.controlFactory.raiseOnChange(that.controlFactory, true);
                that.controlFactory.raiseOnBoolFieldChange(that.controlFactory);
            }
        }).data("kendoDropDownList");
        if (that.initialValue)
            that.setValue(that.initialValue);
        that.combo.enable(!that.readonly);
    }
    destroy() {
        super.destroy();
        let jQueryElem = $("#" + this.id);
        if (jQueryElem.data("kendoDropDownList"))
            jQueryElem.data("kendoDropDownList").destroy();
    }
    getDOMControl() {
        return $("#" + this.id).closest(".k-widget");
    }
    setValue(value) {
        if (typeof value === "string" && ["Y", "N", ""].indexOf(value) > -1)
            this.combo.value(value);
    }
    getValue() {
        let val = this.combo.dataItem(this.combo.select()).value;
        return this.convertBack(val, true);
    }
    setLayoutBoolComboBoxControl(layout) {
        if (layout === "absolute") {
            this.getDOMControl().find("span.k-input").css({
                height: this.height + "px"
            });
            this.getDOMControl().find("span.k-select").css({
                height: this.height + "px"
            });
        }
    }
    setFocus() {
    }
    setLayout(layout) {
        super.setLayout(layout);
        this.setLayoutBoolComboBoxControl(layout);
    }
    setLayoutAnimated(layout) {
        super.setLayoutAnimated(layout);
        this.setLayoutBoolComboBoxControl(layout);
    }
}
class StaticImageControl extends Control {
    constructor(prependId, typeId, mode, controlDef, controlFactory) {
        super(prependId, typeId, mode, controlDef, controlFactory);
        this.imageDocId = controlDef.imageDocId;
        this.desiredWidth = controlDef.desiredWidth;
        this.desiredHeight = controlDef.desiredHeight;
    }
    setValue(value) {
        let oldVal = this.imageDocId;
        this.imageDocId = value.toString();
        if (oldVal !== this.imageDocId)
            this.notifyChange();
    }
    notifyChange() {
        const that = this;
        if (that.imageDocId) {
            $("#" + that.id).css({
                "background-image": "url('" + Utilities_1.synUtil.getWSUrl("IconRect")
                    + "docid=" + that.imageDocId
                    + "/" + parseInt(that.desiredWidth, 10).toString()
                    + "/" + parseInt(that.desiredHeight, 10).toString()
                    + "')"
            });
        }
        else
            $("#" + that.id).css("background-image", "");
    }
    init(jqueryElem) {
        jqueryElem.css("background-position", "50% 50%");
        jqueryElem.css("background-repeat", "no-repeat");
        this.notifyChange();
    }
    lateInit(elem) {
    }
}
class LineControl extends Control {
    constructor(prependId, typeId, mode, controlDef, controlFactory) {
        super(prependId, typeId, mode, controlDef, controlFactory);
        this.isVertical = (controlDef.type === "VLineInfo");
        this.cssClasses.push("ppStatic");
        this.cssClasses.push("ppLine");
        this.cssClasses.push(this.isVertical ? "ppVertical" : "ppHorizontal");
    }
    init(jqueryElem) {
        let svg = $(this.SVG("svg"))
            .attr("class", "ppLine " + (this.isVertical ? "ppLVert" : "ppLHoriz"))
            .appendTo(jqueryElem);
        let lineElem = $(this.SVG("line"))
            .appendTo(svg);
        if (this.isVertical)
            lineElem.attr("y2", this.height);
        else
            lineElem.attr("x2", this.width);
    }
    setLayout(layout) {
        this.layout = layout;
        let strDisplay = "";
        if (!this.visibleDynamic)
            strDisplay = "none";
        if (layout === "absolute") {
            this.getDOMControl().css({
                width: this.width + "px",
                height: this.height + "px",
                top: this.top + "px",
                left: this.left + "px",
                position: "absolute",
                display: strDisplay
            });
        }
        else
            this.getDOMControl().css("display", "none");
        // Hinweis: eigentlich fehlt an dieser Stelle noch die Veränderung von svg.line. Siehe dazu setLayoutAnimated.
    }
    setLayoutAnimated(layout) {
        if (layout === "absolute") {
            // Hier fehlt noch die animation - das müsste noch implementiert werden
            //super.setLayoutAnimated(layout);
            super.setLayout(layout); // setLayout sieht statt super.setLayoutAnimated eine Spur besser aus, da wir an dieser Stelle die Animation noch nicht hinbekommen haben.
            let controlToAnimate = this.getDOMControl().children("svg").children("line");
            if (this.isVertical) {
                // Animation habe ich da noch nicht korrekt hinbekommen
                controlToAnimate.attr("y2", this.height);
            }
            else
                // Animation habe ich da noch nicht korrekt hinbekommen
                controlToAnimate.attr("x2", this.width);
        }
        else
            this.getDOMControl().css("display", "none");
    }
    lateInit(elem) {
    }
}
class Panel extends Control {
    constructor(prependId, typeId, mode, controlDef, controlFactory) {
        super(prependId, typeId, mode, controlDef, controlFactory);
        this.isGroupBox = false;
        this.cssClasses.push("ppStatic");
        this.cssClasses.push("ppPanelControl");
        if (controlDef.type === "GroupBoxInfo") {
            this.isGroupBox = true;
            this.text = "\u200b" + controlDef.text + "\u200b";
            this.textKey = controlDef.textKey;
            this.cssClasses.push("ppGroupBox");
        }
    }
    init(jqueryElem) {
        let svg = $(this.SVG("svg"))
            .attr("class", "ppPanel")
            .appendTo(jqueryElem);
        let placementX = 10;
        let placementY = 2;
        if (this.isGroupBox) {
            let rectElem = $(this.SVG("rect"))
                .attr("x", placementX.toString())
                .attr("y", placementY.toString())
                .attr("class", "gbLabelRect")
                .appendTo(svg);
            let textElem = $(this.SVG("text"))
                .attr("x", placementX.toString())
                .attr("y", placementY.toString())
                .attr("class", "gbLabel")
                .text(this.text)
                .appendTo(svg);
            if (this.fontOptions && this.fontOptions.underline)
                textElem.attr("text-decoration", "underline");
            else if (this.fontOptions && this.fontOptions.strikeOut)
                textElem.attr("text-decoration", "line-through");
            let h = this.height;
            let w = this.width;
            let tw = textElem[0].getBoundingClientRect().width;
            let th = textElem[0].getBoundingClientRect().height;
            rectElem.attr("width", tw.toString()).attr("height", th.toString()).attr("y", (-th / 4).toString());
            textElem.attr("y", (th / 2));
            $(this.SVG("path"))
                .attr("d", this.getPath(w, h, placementX, placementY, tw, th))
                .attr("class", "border groupBox")
                .appendTo(svg);
        }
        else {
            $(this.SVG("rect"))
                .attr("width", this.width)
                .attr("height", this.height)
                .attr("class", "border")
                .appendTo(svg);
        }
    }
    getPath(controlWidth, controlHeight, textX, textY, textWidth, textHeight) {
        textX -= 2;
        textWidth += 2;
        return "M" + textX + "," + textY + " L0," + textY + " L0," + controlHeight + " L" + controlWidth + "," + controlHeight + " L" + controlWidth + "," + textY + " L" + (textX + textWidth) + "," + textY + " "
            + "L" + (textX + textWidth) + "," + (textY + (textHeight / 2))
            + " L" + textX + "," + (textY + (textHeight / 2)) + " L" + textX + "," + textY;
    }
    setLayout(layout) {
        this.layout = layout;
        let strDisplay = "";
        if (!this.visibleDynamic)
            strDisplay = "none";
        if (layout === "absolute") {
            this.getDOMControl().css({
                width: this.width + "px",
                height: this.height + "px",
                top: this.top + "px",
                left: this.left + "px",
                position: "absolute",
                display: strDisplay
            });
            // Hinweis: durch die dynamisch sichbaren Controls kann sich die Höhe der GroupBox dynamisch verändern -->
            // Auch das svg-path-Element muss angepasst werden!
            let groupBox = this.getDOMControl().find("svg > path");
            if (groupBox.length === 1) {
                let placementX = 10;
                let placementY = 2;
                let textElem = this.getDOMControl().find("svg > text");
                if (textElem.length === 1) {
                    let tw = textElem[0].getBoundingClientRect().width;
                    let th = textElem[0].getBoundingClientRect().height;
                    groupBox.attr("d", this.getPath(this.width, this.height, placementX, placementY, tw, th));
                }
            }
        }
        else
            this.getDOMControl().css("display", "none");
    }
    setLayoutAnimated(layout) {
        if (this.isGroupBox) {
            // Hier fehlt noch die animation - das müsste noch implementiert werden
            this.setLayout(layout);
        }
        else {
            if (layout === "absolute") {
                super.setLayoutAnimated(layout);
                let controlToAnimate = this.getDOMControl().children("svg").children("rect");
                controlToAnimate.animate({
                    width: this.width + "px",
                    height: this.height + "px",
                }, {
                    duration: gl_animationDuration,
                    step(value, properties) {
                        // Wird das folgende nicht gemacht, dann stimmt die Darstellung im IE und im Edge NICHT. Das Panel hat dann die falsche Höhe!
                        if (properties.prop === "width")
                            controlToAnimate.attr("width", value + "px");
                        else
                            controlToAnimate.attr("height", value + "px");
                    }
                });
            }
            else
                this.getDOMControl().css("display", "none");
        }
    }
    lateInit(elem) {
    }
}
class StaticTextControl extends Control {
    constructor(prependId, typeId, mode, controlDef, controlFactory) {
        super(prependId, typeId, mode, controlDef, controlFactory);
        this.cssClasses.push("ppStatic");
        this.cssClasses.push("ppLabel");
        this.append = "<span>" + kendo.htmlEncode("\u200b" + controlDef.text + "\u200b") + "</span>";
        this.text = controlDef.text;
        this.textKey = controlDef.textKey;
        this.tag = "span";
    }
    setLayoutStaticTextControl(layout) {
        if (layout !== "absolute") {
            if (this.key.indexOf(".Static") !== this.key.length - 7)
                this.getDOMControl().css("display", "none");
        }
    }
    setLayout(layout) {
        super.setLayout(layout);
        this.setLayoutStaticTextControl(layout);
    }
    setLayoutAnimated(layout) {
        super.setLayoutAnimated(layout);
        this.setLayoutStaticTextControl(layout);
    }
    lateInit(elem) {
    }
    init(jQueryElem) {
    }
}
exports.StaticTextControl = StaticTextControl;
//#endregion Control classes
//#endregion Classes
